const CountriesList = [
    {
      name: "Afghanistan",
      nameRu: "Афганистан",
      alpha2Code: "AF",
      alpha3Code: "AFG",
      callingCodes: [
        "93"
      ],
      capital: "Kabul",
      region: "Asia",
      latlng: [
        33,
        65
      ],
      demonym: "Afghan",
      timezones: [
        "UTC+04:30"
      ],
      flag: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg",
      currencies: [
        {
          code: "AFN",
          name: "Afghan afghani",
          symbol: "؋"
        }
      ]
    },
    {
      name: "Åland Islands",
      nameRu: "Аландские Острова",
      alpha2Code: "AX",
      alpha3Code: "ALA",
      callingCodes: [
        "358"
      ],
      capital: "Mariehamn",
      region: "Europe",
      latlng: [
        60.116667,
        19.9
      ],
      demonym: "Ålandish",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ax.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Albania",
      nameRu: "Албания",
      alpha2Code: "AL",
      alpha3Code: "ALB",
      callingCodes: [
        "355"
      ],
      capital: "Tirana",
      region: "Europe",
      latlng: [
        41,
        20
      ],
      demonym: "Albanian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/al.svg",
      currencies: [
        {
          code: "ALL",
          name: "Albanian lek",
          symbol: "L"
        }
      ]
    },
    {
      name: "Algeria",
      nameRu: "Алжир",
      alpha2Code: "DZ",
      alpha3Code: "DZA",
      callingCodes: [
        "213"
      ],
      capital: "Algiers",
      region: "Africa",
      latlng: [
        28,
        3
      ],
      demonym: "Algerian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dz.svg",
      currencies: [
        {
          code: "DZD",
          name: "Algerian dinar",
          symbol: "د.ج"
        }
      ]
    },
    {
      name: "American Samoa",
      nameRu: "Американское Самоа",
      alpha2Code: "AS",
      alpha3Code: "ASM",
      callingCodes: [
        "1"
      ],
      capital: "Pago Pago",
      region: "Oceania",
      latlng: [
        -14.33333333,
        -170
      ],
      demonym: "American Samoan",
      timezones: [
        "UTC-11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/as.svg",
      currencies: [
        {
          code: "USD",
          name: "United States Dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Andorra",
      nameRu: "Андорра",
      alpha2Code: "AD",
      alpha3Code: "AND",
      callingCodes: [
        "376"
      ],
      capital: "Andorra la Vella",
      region: "Europe",
      latlng: [
        42.5,
        1.5
      ],
      demonym: "Andorran",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ad.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Angola",
      nameRu: "Ангола",
      alpha2Code: "AO",
      alpha3Code: "AGO",
      callingCodes: [
        "244"
      ],
      capital: "Luanda",
      region: "Africa",
      latlng: [
        -12.5,
        18.5
      ],
      demonym: "Angolan",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ao.svg",
      currencies: [
        {
          code: "AOA",
          name: "Angolan kwanza",
          symbol: "Kz"
        }
      ]
    },
    {
      name: "Anguilla",
      nameRu: "Ангилья",
      alpha2Code: "AI",
      alpha3Code: "AIA",
      callingCodes: [
        "1"
      ],
      capital: "The Valley",
      region: "Americas",
      latlng: [
        18.25,
        -63.16666666
      ],
      demonym: "Anguillian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ai.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Antarctica",
      nameRu: "Антарктика",
      alpha2Code: "AQ",
      alpha3Code: "ATA",
      callingCodes: [
        "672"
      ],
      capital: null,
      region: "Polar",
      latlng: [
        -74.65,
        4.48
      ],
      demonym: "Antarctic",
      timezones: [
        "UTC-03:00",
        "UTC+03:00",
        "UTC+05:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/aq.svg",
      currencies: null
    },
    {
      name: "Antigua and Barbuda",
      nameRu: "Антигуа и Барбуда",
      alpha2Code: "AG",
      alpha3Code: "ATG",
      callingCodes: [
        "1"
      ],
      capital: "Saint John's",
      region: "Americas",
      latlng: [
        17.05,
        -61.8
      ],
      demonym: "Antiguan, Barbudan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ag.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Argentina",
      nameRu: "Аргентина",
      alpha2Code: "AR",
      alpha3Code: "ARG",
      callingCodes: [
        "54"
      ],
      capital: "Buenos Aires",
      region: "Americas",
      latlng: [
        -34,
        -64
      ],
      demonym: "Argentinean",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ar.svg",
      currencies: [
        {
          code: "ARS",
          name: "Argentine peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Armenia",
      nameRu: "Армения",
      alpha2Code: "AM",
      alpha3Code: "ARM",
      callingCodes: [
        "374"
      ],
      capital: "Yerevan",
      region: "Asia",
      latlng: [
        40,
        45
      ],
      demonym: "Armenian",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/am.svg",
      currencies: [
        {
          code: "AMD",
          name: "Armenian dram",
          symbol: "֏"
        }
      ]
    },
    {
      name: "Aruba",
      nameRu: "Аруба",
      alpha2Code: "AW",
      alpha3Code: "ABW",
      callingCodes: [
        "297"
      ],
      capital: "Oranjestad",
      region: "Americas",
      latlng: [
        12.5,
        -69.96666666
      ],
      demonym: "Aruban",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/aw.svg",
      currencies: [
        {
          code: "AWG",
          name: "Aruban florin",
          symbol: "ƒ"
        }
      ]
    },
    {
      name: "Australia",
      nameRu: "Австралия",
      alpha2Code: "AU",
      alpha3Code: "AUS",
      callingCodes: [
        "61"
      ],
      capital: "Canberra",
      region: "Oceania",
      latlng: [
        -27,
        133
      ],
      demonym: "Australian",
      timezones: [
        "UTC+05:00",
        "UTC+06:30",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:30",
        "UTC+10:00",
        "UTC+10:30",
        "UTC+11:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/au.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Austria",
      nameRu: "Австрия",
      alpha2Code: "AT",
      alpha3Code: "AUT",
      callingCodes: [
        "43"
      ],
      capital: "Vienna",
      region: "Europe",
      latlng: [
        47.33333333,
        13.33333333
      ],
      demonym: "Austrian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/at.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Azerbaijan",
      nameRu: "Азербайджан",
      alpha2Code: "AZ",
      alpha3Code: "AZE",
      callingCodes: [
        "994"
      ],
      capital: "Baku",
      region: "Asia",
      latlng: [
        40.5,
        47.5
      ],
      demonym: "Azerbaijani",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/az.svg",
      currencies: [
        {
          code: "AZN",
          name: "Azerbaijani manat",
          symbol: "₼"
        }
      ]
    },
    {
      name: "Bahamas",
      nameRu: "Багамские Острова",
      alpha2Code: "BS",
      alpha3Code: "BHS",
      callingCodes: [
        "1"
      ],
      capital: "Nassau",
      region: "Americas",
      latlng: [
        24.25,
        -76
      ],
      demonym: "Bahamian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bs.svg",
      currencies: [
        {
          code: "BSD",
          name: "Bahamian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bahrain",
      nameRu: "Бахрейн",
      alpha2Code: "BH",
      alpha3Code: "BHR",
      callingCodes: [
        "973"
      ],
      capital: "Manama",
      region: "Asia",
      latlng: [
        26,
        50.55
      ],
      demonym: "Bahraini",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bh.svg",
      currencies: [
        {
          code: "BHD",
          name: "Bahraini dinar",
          symbol: ".د.ب"
        }
      ]
    },
    {
      name: "Bangladesh",
      nameRu: "Бангладеш",
      alpha2Code: "BD",
      alpha3Code: "BGD",
      callingCodes: [
        "880"
      ],
      capital: "Dhaka",
      region: "Asia",
      latlng: [
        24,
        90
      ],
      demonym: "Bangladeshi",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bd.svg",
      currencies: [
        {
          code: "BDT",
          name: "Bangladeshi taka",
          symbol: "৳"
        }
      ]
    },
    {
      name: "Barbados",
      nameRu: "Барбадос",
      alpha2Code: "BB",
      alpha3Code: "BRB",
      callingCodes: [
        "1"
      ],
      capital: "Bridgetown",
      region: "Americas",
      latlng: [
        13.16666666,
        -59.53333333
      ],
      demonym: "Barbadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bb.svg",
      currencies: [
        {
          code: "BBD",
          name: "Barbadian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Belarus",
      nameRu: "Белоруссия (Беларусь)",
      alpha2Code: "BY",
      alpha3Code: "BLR",
      callingCodes: [
        "375"
      ],
      capital: "Minsk",
      region: "Europe",
      latlng: [
        53,
        28
      ],
      demonym: "Belarusian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/by.svg",
      currencies: [
        {
          code: "BYN",
          name: "New Belarusian ruble",
          symbol: "Br"
        },
        {
          code: "BYR",
          name: "Old Belarusian ruble",
          symbol: "Br"
        }
      ]
    },
    {
      name: "Belgium",
      nameRu: "Бельгия",
      alpha2Code: "BE",
      alpha3Code: "BEL",
      callingCodes: [
        "32"
      ],
      capital: "Brussels",
      region: "Europe",
      latlng: [
        50.83333333,
        4
      ],
      demonym: "Belgian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/be.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Belize",
      nameRu: "Белиз",
      alpha2Code: "BZ",
      alpha3Code: "BLZ",
      callingCodes: [
        "501"
      ],
      capital: "Belmopan",
      region: "Americas",
      latlng: [
        17.25,
        -88.75
      ],
      demonym: "Belizean",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bz.svg",
      currencies: [
        {
          code: "BZD",
          name: "Belize dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Benin",
      nameRu: "Бенин",
      alpha2Code: "BJ",
      alpha3Code: "BEN",
      callingCodes: [
        "229"
      ],
      capital: "Porto-Novo",
      region: "Africa",
      latlng: [
        9.5,
        2.25
      ],
      demonym: "Beninese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bj.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Bermuda",
      nameRu: "Бермудские Острова",
      alpha2Code: "BM",
      alpha3Code: "BMU",
      callingCodes: [
        "1"
      ],
      capital: "Hamilton",
      region: "Americas",
      latlng: [
        32.33333333,
        -64.75
      ],
      demonym: "Bermudian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bm.svg",
      currencies: [
        {
          code: "BMD",
          name: "Bermudian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bhutan",
      nameRu: "Бутан",
      alpha2Code: "BT",
      alpha3Code: "BTN",
      callingCodes: [
        "975"
      ],
      capital: "Thimphu",
      region: "Asia",
      latlng: [
        27.5,
        90.5
      ],
      demonym: "Bhutanese",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bt.svg",
      currencies: [
        {
          code: "BTN",
          name: "Bhutanese ngultrum",
          symbol: "Nu."
        },
        {
          code: "INR",
          name: "Indian rupee",
          symbol: "₹"
        }
      ]
    },
    {
      name: "Bolivia (Plurinational State of)",
      nameRu: "Боливия",
      alpha2Code: "BO",
      alpha3Code: "BOL",
      callingCodes: [
        "591"
      ],
      capital: "Sucre",
      region: "Americas",
      latlng: [
        -17,
        -65
      ],
      demonym: "Bolivian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bo.svg",
      currencies: [
        {
          code: "BOB",
          name: "Bolivian boliviano",
          symbol: "Bs."
        }
      ]
    },
    {
      name: "Bosnia and Herzegovina",
      nameRu: "Босния и Герцеговина",
      alpha2Code: "BA",
      alpha3Code: "BIH",
      callingCodes: [
        "387"
      ],
      capital: "Sarajevo",
      region: "Europe",
      latlng: [
        44,
        18
      ],
      demonym: "Bosnian, Herzegovinian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ba.svg",
      currencies: [
        {
          code: "BAM",
          name: "Bosnia and Herzegovina convertible mark",
          symbol: "KM"
        }
      ]
    },
    {
      name: "Botswana",
      nameRu: "Ботсвана",
      alpha2Code: "BW",
      alpha3Code: "BWA",
      callingCodes: [
        "267"
      ],
      capital: "Gaborone",
      region: "Africa",
      latlng: [
        -22,
        24
      ],
      demonym: "Motswana",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bw.svg",
      currencies: [
        {
          code: "BWP",
          name: "Botswana pula",
          symbol: "P"
        }
      ]
    },
    {
      name: "Bouvet Island",
      nameRu: "Буве, остров",
      alpha2Code: "BV",
      alpha3Code: "BVT",
      callingCodes: [
        "47"
      ],
      capital: null,
      region: "Antarctic Ocean",
      latlng: [
        -54.43333333,
        3.4
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bv.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Brazil",
      nameRu: "Бразилия",
      alpha2Code: "BR",
      alpha3Code: "BRA",
      callingCodes: [
        "55"
      ],
      capital: "Brasília",
      region: "Americas",
      latlng: [
        -10,
        -55
      ],
      demonym: "Brazilian",
      timezones: [
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/br.svg",
      currencies: [
        {
          code: "BRL",
          name: "Brazilian real",
          symbol: "R$"
        }
      ]
    },
    {
      name: "British Indian Ocean Territory",
      nameRu: "Британская территория в Индийском океане",
      alpha2Code: "IO",
      alpha3Code: "IOT",
      callingCodes: [
        "246"
      ],
      capital: "Diego Garcia",
      region: "Africa",
      latlng: [
        -6,
        71.5
      ],
      demonym: "Indian",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/io.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "United States Minor Outlying Islands",
      nameRu: "Мелкие отдаленные острова США",
      alpha2Code: "UM",
      alpha3Code: "UMI",
      callingCodes: [
        "246"
      ],
      capital: null,
      region: "Americas",
      latlng: null,
      demonym: "American",
      timezones: [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/um.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Virgin Islands (British)",
      nameRu: "Виргинские Острова (британские)",
      alpha2Code: "VG",
      alpha3Code: "VGB",
      callingCodes: [
        "1"
      ],
      capital: "Road Town",
      region: "Americas",
      latlng: [
        18.431383,
        -64.62305
      ],
      demonym: "Virgin Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vg.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Virgin Islands (U.S.)",
      nameRu: "Виргинские Острова (США)",
      alpha2Code: "VI",
      alpha3Code: "VIR",
      callingCodes: [
        "1 340"
      ],
      capital: "Charlotte Amalie",
      region: "Americas",
      latlng: [
        18.34,
        -64.93
      ],
      demonym: "Virgin Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vi.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Brunei Darussalam",
      nameRu: "Бруней",
      alpha2Code: "BN",
      alpha3Code: "BRN",
      callingCodes: [
        "673"
      ],
      capital: "Bandar Seri Begawan",
      region: "Asia",
      latlng: [
        4.5,
        114.66666666
      ],
      demonym: "Bruneian",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bn.svg",
      currencies: [
        {
          code: "BND",
          name: "Brunei dollar",
          symbol: "$"
        },
        {
          code: "SGD",
          name: "Singapore dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bulgaria",
      nameRu: "Болгария",
      alpha2Code: "BG",
      alpha3Code: "BGR",
      callingCodes: [
        "359"
      ],
      capital: "Sofia",
      region: "Europe",
      latlng: [
        43,
        25
      ],
      demonym: "Bulgarian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bg.svg",
      currencies: [
        {
          code: "BGN",
          name: "Bulgarian lev",
          symbol: "лв"
        }
      ]
    },
    {
      name: "Burkina Faso",
      nameRu: "Буркина-Фасо",
      alpha2Code: "BF",
      alpha3Code: "BFA",
      callingCodes: [
        "226"
      ],
      capital: "Ouagadougou",
      region: "Africa",
      latlng: [
        13,
        -2
      ],
      demonym: "Burkinabe",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bf.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Burundi",
      nameRu: "Бурунди",
      alpha2Code: "BI",
      alpha3Code: "BDI",
      callingCodes: [
        "257"
      ],
      capital: "Gitega",
      region: "Africa",
      latlng: [
        -3.5,
        30
      ],
      demonym: "Burundian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bi.svg",
      currencies: [
        {
          code: "BIF",
          name: "Burundian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Cambodia",
      nameRu: "Камбоджа",
      alpha2Code: "KH",
      alpha3Code: "KHM",
      callingCodes: [
        "855"
      ],
      capital: "Phnom Penh",
      region: "Asia",
      latlng: [
        13,
        105
      ],
      demonym: "Cambodian",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kh.svg",
      currencies: [
        {
          code: "KHR",
          name: "Cambodian riel",
          symbol: "៛"
        },
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cameroon",
      nameRu: "Камерун",
      alpha2Code: "CM",
      alpha3Code: "CMR",
      callingCodes: [
        "237"
      ],
      capital: "Yaoundé",
      region: "Africa",
      latlng: [
        6,
        12
      ],
      demonym: "Cameroonian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cm.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Canada",
      nameRu: "Канада",
      alpha2Code: "CA",
      alpha3Code: "CAN",
      callingCodes: [
        "1"
      ],
      capital: "Ottawa",
      region: "Americas",
      latlng: [
        60,
        -95
      ],
      demonym: "Canadian",
      timezones: [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ca.svg",
      currencies: [
        {
          code: "CAD",
          name: "Canadian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cabo Verde",
      nameRu: "Кабо-Верде",
      alpha2Code: "CV",
      alpha3Code: "CPV",
      callingCodes: [
        "238"
      ],
      capital: "Praia",
      region: "Africa",
      latlng: [
        16,
        -24
      ],
      demonym: "Cape Verdian",
      timezones: [
        "UTC-01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cv.svg",
      currencies: [
        {
          code: "CVE",
          name: "Cape Verdean escudo",
          symbol: "Esc"
        }
      ]
    },
    {
      name: "Cayman Islands",
      nameRu: "Кайман, Острова",
      alpha2Code: "KY",
      alpha3Code: "CYM",
      callingCodes: [
        "1"
      ],
      capital: "George Town",
      region: "Americas",
      latlng: [
        19.5,
        -80.5
      ],
      demonym: "Caymanian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ky.svg",
      currencies: [
        {
          code: "KYD",
          name: "Cayman Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Central African Republic",
      nameRu: "Центральноафриканская республика",
      alpha2Code: "CF",
      alpha3Code: "CAF",
      callingCodes: [
        "236"
      ],
      capital: "Bangui",
      region: "Africa",
      latlng: [
        7,
        21
      ],
      demonym: "Central African",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cf.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Chad",
      nameRu: "Чад",
      alpha2Code: "TD",
      alpha3Code: "TCD",
      callingCodes: [
        "235"
      ],
      capital: "N'Djamena",
      region: "Africa",
      latlng: [
        15,
        19
      ],
      demonym: "Chadian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/td.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Chile",
      nameRu: "Чили",
      alpha2Code: "CL",
      alpha3Code: "CHL",
      callingCodes: [
        "56"
      ],
      capital: "Santiago",
      region: "Americas",
      latlng: [
        -30,
        -71
      ],
      demonym: "Chilean",
      timezones: [
        "UTC-06:00",
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cl.svg",
      currencies: [
        {
          code: "CLP",
          name: "Chilean peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "China",
      nameRu: "Китай",
      alpha2Code: "CN",
      alpha3Code: "CHN",
      callingCodes: [
        "86"
      ],
      capital: "Beijing",
      region: "Asia",
      latlng: [
        35,
        105
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cn.svg",
      currencies: [
        {
          code: "CNY",
          name: "Chinese yuan",
          symbol: "¥"
        }
      ]
    },
    {
      name: "Christmas Island",
      nameRu: "Остров Рождества",
      alpha2Code: "CX",
      alpha3Code: "CXR",
      callingCodes: [
        "61"
      ],
      capital: "Flying Fish Cove",
      region: "Oceania",
      latlng: [
        -10.5,
        105.66666666
      ],
      demonym: "Christmas Island",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cx.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cocos (Keeling) Islands",
      nameRu: "Кокосовые (Килинг) Острова",
      alpha2Code: "CC",
      alpha3Code: "CCK",
      callingCodes: [
        "61"
      ],
      capital: "West Island",
      region: "Oceania",
      latlng: [
        -12.5,
        96.83333333
      ],
      demonym: "Cocos Islander",
      timezones: [
        "UTC+06:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cc.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Colombia",
      nameRu: "Колумбия",
      alpha2Code: "CO",
      alpha3Code: "COL",
      callingCodes: [
        "57"
      ],
      capital: "Bogotá",
      region: "Americas",
      latlng: [
        4,
        -72
      ],
      demonym: "Colombian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/co.svg",
      currencies: [
        {
          code: "COP",
          name: "Colombian peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Comoros",
      nameRu: "Коморские Острова",
      alpha2Code: "KM",
      alpha3Code: "COM",
      callingCodes: [
        "269"
      ],
      capital: "Moroni",
      region: "Africa",
      latlng: [
        -12.16666666,
        44.25
      ],
      demonym: "Comoran",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/km.svg",
      currencies: [
        {
          code: "KMF",
          name: "Comorian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Congo",
      nameRu: "Конго",
      alpha2Code: "CG",
      alpha3Code: "COG",
      callingCodes: [
        "242"
      ],
      capital: "Brazzaville",
      region: "Africa",
      latlng: [
        -1,
        15
      ],
      demonym: "Congolese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cg.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Congo (Democratic Republic of the)",
      nameRu: "Демократическая Республика Конго",
      alpha2Code: "CD",
      alpha3Code: "COD",
      callingCodes: [
        "243"
      ],
      capital: "Kinshasa",
      region: "Africa",
      latlng: [
        0,
        25
      ],
      demonym: "Congolese",
      timezones: [
        "UTC+01:00",
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cd.svg",
      currencies: [
        {
          code: "CDF",
          name: "Congolese franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Cook Islands",
      nameRu: "Острова Кука",
      alpha2Code: "CK",
      alpha3Code: "COK",
      callingCodes: [
        "682"
      ],
      capital: "Avarua",
      region: "Oceania",
      latlng: [
        -21.23333333,
        -159.76666666
      ],
      demonym: "Cook Islander",
      timezones: [
        "UTC-10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ck.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "CKD",
          name: "Cook Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Costa Rica",
      nameRu: "Коста-Рика",
      alpha2Code: "CR",
      alpha3Code: "CRI",
      callingCodes: [
        "506"
      ],
      capital: "San José",
      region: "Americas",
      latlng: [
        10,
        -84
      ],
      demonym: "Costa Rican",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cr.svg",
      currencies: [
        {
          code: "CRC",
          name: "Costa Rican colón",
          symbol: "₡"
        }
      ]
    },
    {
      name: "Croatia",
      nameRu: "Хорватия",
      alpha2Code: "HR",
      alpha3Code: "HRV",
      callingCodes: [
        "385"
      ],
      capital: "Zagreb",
      region: "Europe",
      latlng: [
        45.16666666,
        15.5
      ],
      demonym: "Croatian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Cuba",
      nameRu: "Куба",
      alpha2Code: "CU",
      alpha3Code: "CUB",
      callingCodes: [
        "53"
      ],
      capital: "Havana",
      region: "Americas",
      latlng: [
        21.5,
        -80
      ],
      demonym: "Cuban",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cu.svg",
      currencies: [
        {
          code: "CUC",
          name: "Cuban convertible peso",
          symbol: "$"
        },
        {
          code: "CUP",
          name: "Cuban peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Curaçao",
      nameRu: "Кюрасао",
      alpha2Code: "CW",
      alpha3Code: "CUW",
      callingCodes: [
        "599"
      ],
      capital: "Willemstad",
      region: "Americas",
      latlng: [
        12.116667,
        -68.933333
      ],
      demonym: "Dutch",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cw.svg",
      currencies: [
        {
          code: "ANG",
          name: "Netherlands Antillean guilder",
          symbol: "ƒ"
        }
      ]
    },
    {
      name: "Cyprus",
      nameRu: "Кипр",
      alpha2Code: "CY",
      alpha3Code: "CYP",
      callingCodes: [
        "357"
      ],
      capital: "Nicosia",
      region: "Europe",
      latlng: [
        35,
        33
      ],
      demonym: "Cypriot",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cy.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Czech Republic",
      nameRu: "Чешская Республика",
      alpha2Code: "CZ",
      alpha3Code: "CZE",
      callingCodes: [
        "420"
      ],
      capital: "Prague",
      region: "Europe",
      latlng: [
        49.75,
        15.5
      ],
      demonym: "Czech",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cz.svg",
      currencies: [
        {
          code: "CZK",
          name: "Czech koruna",
          symbol: "Kč"
        }
      ]
    },
    {
      name: "Denmark",
      nameRu: "Дания",
      alpha2Code: "DK",
      alpha3Code: "DNK",
      callingCodes: [
        "45"
      ],
      capital: "Copenhagen",
      region: "Europe",
      latlng: [
        56,
        10
      ],
      demonym: "Danish",
      timezones: [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dk.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Djibouti",
      nameRu: "Джибути",
      alpha2Code: "DJ",
      alpha3Code: "DJI",
      callingCodes: [
        "253"
      ],
      capital: "Djibouti",
      region: "Africa",
      latlng: [
        11.5,
        43
      ],
      demonym: "Djibouti",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dj.svg",
      currencies: [
        {
          code: "DJF",
          name: "Djiboutian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Dominica",
      nameRu: "Доминика",
      alpha2Code: "DM",
      alpha3Code: "DMA",
      callingCodes: [
        "1"
      ],
      capital: "Roseau",
      region: "Americas",
      latlng: [
        15.41666666,
        -61.33333333
      ],
      demonym: "Dominican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dm.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Dominican Republic",
      nameRu: "Доминиканская Республика",
      alpha2Code: "DO",
      alpha3Code: "DOM",
      callingCodes: [
        "1"
      ],
      capital: "Santo Domingo",
      region: "Americas",
      latlng: [
        19,
        -70.66666666
      ],
      demonym: "Dominican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/do.svg",
      currencies: [
        {
          code: "DOP",
          name: "Dominican peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Ecuador",
      nameRu: "Эквадор",
      alpha2Code: "EC",
      alpha3Code: "ECU",
      callingCodes: [
        "593"
      ],
      capital: "Quito",
      region: "Americas",
      latlng: [
        -2,
        -77.5
      ],
      demonym: "Ecuadorean",
      timezones: [
        "UTC-06:00",
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ec.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Egypt",
      nameRu: "Египет",
      alpha2Code: "EG",
      alpha3Code: "EGY",
      callingCodes: [
        "20"
      ],
      capital: "Cairo",
      region: "Africa",
      latlng: [
        27,
        30
      ],
      demonym: "Egyptian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/eg.svg",
      currencies: [
        {
          code: "EGP",
          name: "Egyptian pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "El Salvador",
      nameRu: "Сальвадор",
      alpha2Code: "SV",
      alpha3Code: "SLV",
      callingCodes: [
        "503"
      ],
      capital: "San Salvador",
      region: "Americas",
      latlng: [
        13.83333333,
        -88.91666666
      ],
      demonym: "Salvadoran",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sv.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Equatorial Guinea",
      nameRu: "Экваториальная Гвинея",
      alpha2Code: "GQ",
      alpha3Code: "GNQ",
      callingCodes: [
        "240"
      ],
      capital: "Malabo",
      region: "Africa",
      latlng: [
        2,
        10
      ],
      demonym: "Equatorial Guinean",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gq.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Eritrea",
      nameRu: "Эритрея",
      alpha2Code: "ER",
      alpha3Code: "ERI",
      callingCodes: [
        "291"
      ],
      capital: "Asmara",
      region: "Africa",
      latlng: [
        15,
        39
      ],
      demonym: "Eritrean",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/er.svg",
      currencies: [
        {
          code: "ERN",
          name: "Eritrean nakfa",
          symbol: "Nfk"
        }
      ]
    },
    {
      name: "Estonia",
      nameRu: "Эстония",
      alpha2Code: "EE",
      alpha3Code: "EST",
      callingCodes: [
        "372"
      ],
      capital: "Tallinn",
      region: "Europe",
      latlng: [
        59,
        26
      ],
      demonym: "Estonian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ee.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Ethiopia",
      nameRu: "Эфиопия",
      alpha2Code: "ET",
      alpha3Code: "ETH",
      callingCodes: [
        "251"
      ],
      capital: "Addis Ababa",
      region: "Africa",
      latlng: [
        8,
        38
      ],
      demonym: "Ethiopian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/et.svg",
      currencies: [
        {
          code: "ETB",
          name: "Ethiopian birr",
          symbol: "Br"
        }
      ]
    },
    {
      name: "Falkland Islands (Malvinas)",
      nameRu: "Фолклендские (Мальвинские) Острова",
      alpha2Code: "FK",
      alpha3Code: "FLK",
      callingCodes: [
        "500"
      ],
      capital: "Stanley",
      region: "Americas",
      latlng: [
        -51.75,
        -59
      ],
      demonym: "Falkland Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fk.svg",
      currencies: [
        {
          code: "FKP",
          name: "Falkland Islands pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Faroe Islands",
      nameRu: "Фарерские Острова",
      alpha2Code: "FO",
      alpha3Code: "FRO",
      callingCodes: [
        "298"
      ],
      capital: "Tórshavn",
      region: "Europe",
      latlng: [
        62,
        -7
      ],
      demonym: "Faroese",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fo.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        },
        {
          code: "FOK",
          name: "Faroese króna",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Fiji",
      nameRu: "Фиджи",
      alpha2Code: "FJ",
      alpha3Code: "FJI",
      callingCodes: [
        "679"
      ],
      capital: "Suva",
      region: "Oceania",
      latlng: [
        -18,
        175
      ],
      demonym: "Fijian",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fj.svg",
      currencies: [
        {
          code: "FJD",
          name: "Fijian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Finland",
      nameRu: "Финляндия",
      alpha2Code: "FI",
      alpha3Code: "FIN",
      callingCodes: [
        "358"
      ],
      capital: "Helsinki",
      region: "Europe",
      latlng: [
        64,
        26
      ],
      demonym: "Finnish",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fi.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "France",
      nameRu: "Франция",
      alpha2Code: "FR",
      alpha3Code: "FRA",
      callingCodes: [
        "33"
      ],
      capital: "Paris",
      region: "Europe",
      latlng: [
        46,
        2
      ],
      demonym: "French",
      timezones: [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+03:00",
        "UTC+04:00",
        "UTC+05:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "French Guiana",
      nameRu: "Французская Гвиана",
      alpha2Code: "GF",
      alpha3Code: "GUF",
      callingCodes: [
        "594"
      ],
      capital: "Cayenne",
      region: "Americas",
      latlng: [
        4,
        -53
      ],
      demonym: "French Guianan",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gf.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "French Polynesia",
      nameRu: "Французская Полинезия",
      alpha2Code: "PF",
      alpha3Code: "PYF",
      callingCodes: [
        "689"
      ],
      capital: "Papeetē",
      region: "Oceania",
      latlng: [
        -15,
        -140
      ],
      demonym: "French Polynesian",
      timezones: [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pf.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "French Southern Territories",
      nameRu: "Французские Южные Территории",
      alpha2Code: "TF",
      alpha3Code: "ATF",
      callingCodes: [
        "262"
      ],
      capital: "Port-aux-Français",
      region: "Africa",
      latlng: [
        -49.25,
        69.167
      ],
      demonym: "French",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tf.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Gabon",
      nameRu: "Габон",
      alpha2Code: "GA",
      alpha3Code: "GAB",
      callingCodes: [
        "241"
      ],
      capital: "Libreville",
      region: "Africa",
      latlng: [
        -1,
        11.75
      ],
      demonym: "Gabonese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ga.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Gambia",
      nameRu: "Гамбия",
      alpha2Code: "GM",
      alpha3Code: "GMB",
      callingCodes: [
        "220"
      ],
      capital: "Banjul",
      region: "Africa",
      latlng: [
        13.46666666,
        -16.56666666
      ],
      demonym: "Gambian",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gm.svg",
      currencies: [
        {
          code: "GMD",
          name: "Gambian dalasi",
          symbol: "D"
        }
      ]
    },
    {
      name: "Georgia",
      nameRu: "Грузия",
      alpha2Code: "GE",
      alpha3Code: "GEO",
      callingCodes: [
        "995"
      ],
      capital: "Tbilisi",
      region: "Asia",
      latlng: [
        42,
        43.5
      ],
      demonym: "Georgian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ge.svg",
      currencies: [
        {
          code: "GEL",
          name: "Georgian Lari",
          symbol: "ლ"
        }
      ]
    },
    {
      name: "Germany",
      nameRu: "Германия",
      alpha2Code: "DE",
      alpha3Code: "DEU",
      callingCodes: [
        "49"
      ],
      capital: "Berlin",
      region: "Europe",
      latlng: [
        51,
        9
      ],
      demonym: "German",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/de.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Ghana",
      nameRu: "Гана",
      alpha2Code: "GH",
      alpha3Code: "GHA",
      callingCodes: [
        "233"
      ],
      capital: "Accra",
      region: "Africa",
      latlng: [
        8,
        -2
      ],
      demonym: "Ghanaian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gh.svg",
      currencies: [
        {
          code: "GHS",
          name: "Ghanaian cedi",
          symbol: "₵"
        }
      ]
    },
    {
      name: "Gibraltar",
      nameRu: "Гибралтар",
      alpha2Code: "GI",
      alpha3Code: "GIB",
      callingCodes: [
        "350"
      ],
      capital: "Gibraltar",
      region: "Europe",
      latlng: [
        36.13333333,
        -5.35
      ],
      demonym: "Gibraltar",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gi.svg",
      currencies: [
        {
          code: "GIP",
          name: "Gibraltar pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Greece",
      NameRu: "Греция",
      alpha2Code: "GR",
      alpha3Code: "GRC",
      callingCodes: [
        "30"
      ],
      capital: "Athens",
      region: "Europe",
      latlng: [
        39,
        22
      ],
      demonym: "Greek",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Greenland",
      nameRu: "Гренландия",
      alpha2Code: "GL",
      alpha3Code: "GRL",
      callingCodes: [
        "299"
      ],
      capital: "Nuuk",
      region: "Americas",
      latlng: [
        72,
        -40
      ],
      demonym: "Greenlandic",
      timezones: [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gl.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Grenada",
      nameRu: "Гренада",
      alpha2Code: "GD",
      alpha3Code: "GRD",
      callingCodes: [
        "1"
      ],
      capital: "St. George's",
      region: "Americas",
      latlng: [
        12.11666666,
        -61.66666666
      ],
      demonym: "Grenadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gd.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Guadeloupe",
      nameRu: "Гваделупа",
      alpha2Code: "GP",
      alpha3Code: "GLP",
      callingCodes: [
        "590"
      ],
      capital: "Basse-Terre",
      region: "Americas",
      latlng: [
        16.25,
        -61.583333
      ],
      demonym: "Guadeloupian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gp.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Guam",
      nameRu: "Гуам",
      alpha2Code: "GU",
      alpha3Code: "GUM",
      callingCodes: [
        "1"
      ],
      capital: "Hagåtña",
      region: "Oceania",
      latlng: [
        13.46666666,
        144.78333333
      ],
      demonym: "Guamanian",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gu.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Guatemala",
      nameRu: "Гватемала",
      alpha2Code: "GT",
      alpha3Code: "GTM",
      callingCodes: [
        "502"
      ],
      capital: "Guatemala City",
      region: "Americas",
      latlng: [
        15.5,
        -90.25
      ],
      demonym: "Guatemalan",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gt.svg",
      currencies: [
        {
          code: "GTQ",
          name: "Guatemalan quetzal",
          symbol: "Q"
        }
      ]
    },
    {
      name: "Guernsey",
      nameRu: "Гернси",
      alpha2Code: "GG",
      alpha3Code: "GGY",
      callingCodes: [
        "44"
      ],
      capital: "St. Peter Port",
      region: "Europe",
      latlng: [
        49.46666666,
        -2.58333333
      ],
      demonym: "Channel Islander",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gg.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "GGP",
          name: "Guernsey pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Guinea",
      nameRu: "Гвинея",
      alpha2Code: "GN",
      alpha3Code: "GIN",
      callingCodes: [
        "224"
      ],
      capital: "Conakry",
      region: "Africa",
      latlng: [
        11,
        -10
      ],
      demonym: "Guinean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gn.svg",
      currencies: [
        {
          code: "GNF",
          name: "Guinean franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Guinea-Bissau",
      nameRu: "Гвинея-Бисау",
      alpha2Code: "GW",
      alpha3Code: "GNB",
      callingCodes: [
        "245"
      ],
      capital: "Bissau",
      region: "Africa",
      latlng: [
        12,
        -15
      ],
      demonym: "Guinea-Bissauan",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gw.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Guyana",
      nameRu: "Гайана",
      alpha2Code: "GY",
      alpha3Code: "GUY",
      callingCodes: [
        "592"
      ],
      capital: "Georgetown",
      region: "Americas",
      latlng: [
        5,
        -59
      ],
      demonym: "Guyanese",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gy.svg",
      currencies: [
        {
          code: "GYD",
          name: "Guyanese dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Haiti",
      nameRu: "Гаити",
      alpha2Code: "HT",
      alpha3Code: "HTI",
      callingCodes: [
        "509"
      ],
      capital: "Port-au-Prince",
      region: "Americas",
      latlng: [
        19,
        -72.41666666
      ],
      demonym: "Haitian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ht.svg",
      currencies: [
        {
          code: "HTG",
          name: "Haitian gourde",
          symbol: "G"
        }
      ]
    },
    {
      name: "Heard Island and McDonald Islands",
      nameRu: "Херд и Макдональн, острова",
      alpha2Code: "HM",
      alpha3Code: "HMD",
      callingCodes: [
        "672"
      ],
      capital: null,
      region: "Antarctic",
      latlng: [
        -53.1,
        72.51666666
      ],
      demonym: "Heard and McDonald Islander",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hm.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Vatican City",
      nameRu: "Ватикан",
      alpha2Code: "VA",
      alpha3Code: "VAT",
      callingCodes: [
        "379"
      ],
      capital: "Vatican City",
      region: "Europe",
      latlng: [
        41.9,
        12.45
      ],
      demonym: "Vatican",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/va.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Honduras",
      nameRu: "Гондурас",
      alpha2Code: "HN",
      alpha3Code: "HND",
      callingCodes: [
        "504"
      ],
      capital: "Tegucigalpa",
      region: "Americas",
      latlng: [
        15,
        -86.5
      ],
      demonym: "Honduran",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hn.svg",
      currencies: [
        {
          code: "HNL",
          name: "Honduran lempira",
          symbol: "L"
        }
      ]
    },
    {
      name: "Hungary",
      nameRu: "Венгрия",
      alpha2Code: "HU",
      alpha3Code: "HUN",
      callingCodes: [
        "36"
      ],
      capital: "Budapest",
      region: "Europe",
      latlng: [
        47,
        20
      ],
      demonym: "Hungarian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hu.svg",
      currencies: [
        {
          code: "HUF",
          name: "Hungarian forint",
          symbol: "Ft"
        }
      ]
    },
    {
      name: "Hong Kong",
      nameRu: "Гонконг (Сянган)",
      alpha2Code: "HK",
      alpha3Code: "HKG",
      callingCodes: [
        "852"
      ],
      capital: "City of Victoria",
      region: "Asia",
      latlng: [
        22.25,
        114.16666666
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hk.svg",
      currencies: [
        {
          code: "HKD",
          name: "Hong Kong dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Iceland",
      nameRu: "Исландия",
      alpha2Code: "IS",
      alpha3Code: "ISL",
      callingCodes: [
        "354"
      ],
      capital: "Reykjavík",
      region: "Europe",
      latlng: [
        65,
        -18
      ],
      demonym: "Icelander",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/is.svg",
      currencies: [
        {
          code: "ISK",
          name: "Icelandic króna",
          symbol: "kr"
        }
      ]
    },
    {
      name: "India",
      nameRu: "Индия",
      alpha2Code: "IN",
      alpha3Code: "IND",
      callingCodes: [
        "91"
      ],
      capital: "New Delhi",
      region: "Asia",
      latlng: [
        20,
        77
      ],
      demonym: "Indian",
      timezones: [
        "UTC+05:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/in.svg",
      currencies: [
        {
          code: "INR",
          name: "Indian rupee",
          symbol: "₹"
        }
      ]
    },
    {
      name: "Indonesia",
      nameRu: "Индонезия",
      alpha2Code: "ID",
      alpha3Code: "IDN",
      callingCodes: [
        "62"
      ],
      capital: "Jakarta",
      region: "Asia",
      latlng: [
        -5,
        120
      ],
      demonym: "Indonesian",
      timezones: [
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/id.svg",
      currencies: [
        {
          code: "IDR",
          name: "Indonesian rupiah",
          symbol: "Rp"
        }
      ]
    },
    {
      name: "Ivory Coast",
      nameRu: "Кот-д'Ивуар",
      alpha2Code: "CI",
      alpha3Code: "CIV",
      callingCodes: [
        "225"
      ],
      capital: "Yamoussoukro",
      region: "Africa",
      latlng: [
        8,
        -5
      ],
      demonym: "Ivorian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ci.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Iran (Islamic Republic of)",
      nameRu: "Иран",
      alpha2Code: "IR",
      alpha3Code: "IRN",
      callingCodes: [
        "98"
      ],
      capital: "Tehran",
      region: "Asia",
      latlng: [
        32,
        53
      ],
      demonym: "Iranian",
      timezones: [
        "UTC+03:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ir.svg",
      currencies: [
        {
          code: "IRR",
          name: "Iranian rial",
          symbol: "﷼"
        }
      ]
    },
    {
      name: "Iraq",
      nameRu: "Ирак",
      alpha2Code: "IQ",
      alpha3Code: "IRQ",
      callingCodes: [
        "964"
      ],
      capital: "Baghdad",
      region: "Asia",
      latlng: [
        33,
        44
      ],
      demonym: "Iraqi",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/iq.svg",
      currencies: [
        {
          code: "IQD",
          name: "Iraqi dinar",
          symbol: "ع.د"
        }
      ]
    },
    {
      name: "Ireland",
      nameRu: "Ирландия",
      alpha2Code: "IE",
      alpha3Code: "IRL",
      callingCodes: [
        "353"
      ],
      capital: "Dublin",
      region: "Europe",
      latlng: [
        53,
        -8
      ],
      demonym: "Irish",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ie.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Isle of Man",
      nameRu: "Остров Мэн",
      alpha2Code: "IM",
      alpha3Code: "IMN",
      callingCodes: [
        "44"
      ],
      capital: "Douglas",
      region: "Europe",
      latlng: [
        54.25,
        -4.5
      ],
      demonym: "Manx",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/im.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "IMP[G]",
          name: "Manx pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Israel",
      nameRu: "Израиль",
      alpha2Code: "IL",
      alpha3Code: "ISR",
      callingCodes: [
        "972"
      ],
      capital: "Jerusalem",
      region: "Asia",
      latlng: [
        31.5,
        34.75
      ],
      demonym: "Israeli",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/il.svg",
      currencies: [
        {
          code: "ILS",
          name: "Israeli new shekel",
          symbol: "₪"
        }
      ]
    },
    {
      name: "Italy",
      nameRu: "Италия",
      alpha2Code: "IT",
      alpha3Code: "ITA",
      callingCodes: [
        "39"
      ],
      capital: "Rome",
      region: "Europe",
      latlng: [
        42.83333333,
        12.83333333
      ],
      demonym: "Italian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/it.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Jamaica",
      nameRu: "Ямайка",
      alpha2Code: "JM",
      alpha3Code: "JAM",
      callingCodes: [
        "1"
      ],
      capital: "Kingston",
      region: "Americas",
      latlng: [
        18.25,
        -77.5
      ],
      demonym: "Jamaican",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jm.svg",
      currencies: [
        {
          code: "JMD",
          name: "Jamaican dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Japan",
      nameRu: "Япония",
      alpha2Code: "JP",
      alpha3Code: "JPN",
      callingCodes: [
        "81"
      ],
      capital: "Tokyo",
      region: "Asia",
      latlng: [
        36,
        138
      ],
      demonym: "Japanese",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jp.svg",
      currencies: [
        {
          code: "JPY",
          name: "Japanese yen",
          symbol: "¥"
        }
      ]
    },
    {
      name: "Jersey",
      nameRu: "Джерси",
      alpha2Code: "JE",
      alpha3Code: "JEY",
      callingCodes: [
        "44"
      ],
      capital: "Saint Helier",
      region: "Europe",
      latlng: [
        49.25,
        -2.16666666
      ],
      demonym: "Channel Islander",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/je.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "JEP[G]",
          name: "Jersey pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Jordan",
      nameRu: "Иордания",
      alpha2Code: "JO",
      alpha3Code: "JOR",
      callingCodes: [
        "962"
      ],
      capital: "Amman",
      region: "Asia",
      latlng: [
        31,
        36
      ],
      demonym: "Jordanian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jo.svg",
      currencies: [
        {
          code: "JOD",
          name: "Jordanian dinar",
          symbol: "د.ا"
        }
      ]
    },
    {
      name: "Kazakhstan",
      nameRu: "Казахстан",
      alpha2Code: "KZ",
      alpha3Code: "KAZ",
      callingCodes: [
        "76",
        "77"
      ],
      capital: "Nur-Sultan",
      region: "Asia",
      latlng: [
        48,
        68
      ],
      demonym: "Kazakhstani",
      timezones: [
        "UTC+05:00",
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kz.svg",
      currencies: [
        {
          code: "KZT",
          name: "Kazakhstani tenge",
          symbol: "₸"
        }
      ]
    },
    {
      name: "Kenya",
      nameRu: "Кения",
      alpha2Code: "KE",
      alpha3Code: "KEN",
      callingCodes: [
        "254"
      ],
      capital: "Nairobi",
      region: "Africa",
      latlng: [
        1,
        38
      ],
      demonym: "Kenyan",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ke.svg",
      currencies: [
        {
          code: "KES",
          name: "Kenyan shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Kiribati",
      nameRu: "Кирибати",
      alpha2Code: "KI",
      alpha3Code: "KIR",
      callingCodes: [
        "686"
      ],
      capital: "South Tarawa",
      region: "Oceania",
      latlng: [
        1.41666666,
        173
      ],
      demonym: "I-Kiribati",
      timezones: [
        "UTC+12:00",
        "UTC+13:00",
        "UTC+14:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ki.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        },
        {
          code: "KID",
          name: "Kiribati dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Kuwait",
      nameRu: "Кувейт",
      alpha2Code: "KW",
      alpha3Code: "KWT",
      callingCodes: [
        "965"
      ],
      capital: "Kuwait City",
      region: "Asia",
      latlng: [
        29.5,
        45.75
      ],
      demonym: "Kuwaiti",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kw.svg",
      currencies: [
        {
          code: "KWD",
          name: "Kuwaiti dinar",
          symbol: "د.ك"
        }
      ]
    },
    {
      name: "Kyrgyzstan",
      nameRu: "Киргизия (Кыргызстан)",
      alpha2Code: "KG",
      alpha3Code: "KGZ",
      callingCodes: [
        "996"
      ],
      capital: "Bishkek",
      region: "Asia",
      latlng: [
        41,
        75
      ],
      demonym: "Kirghiz",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kg.svg",
      currencies: [
        {
          code: "KGS",
          name: "Kyrgyzstani som",
          symbol: "с"
        }
      ]
    },
    {
      name: "Lao People's Democratic Republic",
      nameRu: "Лаос",
      alpha2Code: "LA",
      alpha3Code: "LAO",
      callingCodes: [
        "856"
      ],
      capital: "Vientiane",
      region: "Asia",
      latlng: [
        18,
        105
      ],
      demonym: "Laotian",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/la.svg",
      currencies: [
        {
          code: "LAK",
          name: "Lao kip",
          symbol: "₭"
        }
      ]
    },
    {
      name: "Latvia",
      nameRu: "Латвия",
      alpha2Code: "LV",
      alpha3Code: "LVA",
      callingCodes: [
        "371"
      ],
      capital: "Riga",
      region: "Europe",
      latlng: [
        57,
        25
      ],
      demonym: "Latvian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lv.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Lebanon",
      nameRu: "Ливан",
      alpha2Code: "LB",
      alpha3Code: "LBN",
      callingCodes: [
        "961"
      ],
      capital: "Beirut",
      region: "Asia",
      latlng: [
        33.83333333,
        35.83333333
      ],
      demonym: "Lebanese",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lb.svg",
      currencies: [
        {
          code: "LBP",
          name: "Lebanese pound",
          symbol: "ل.ل"
        }
      ]
    },
    {
      name: "Lesotho",
      nameRu: "Лесото",
      alpha2Code: "LS",
      alpha3Code: "LSO",
      callingCodes: [
        "266"
      ],
      capital: "Maseru",
      region: "Africa",
      latlng: [
        -29.5,
        28.5
      ],
      demonym: "Mosotho",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ls.svg",
      currencies: [
        {
          code: "LSL",
          name: "Lesotho loti",
          symbol: "L"
        },
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "Liberia",
      nameRu: "Либерия",
      alpha2Code: "LR",
      alpha3Code: "LBR",
      callingCodes: [
        "231"
      ],
      capital: "Monrovia",
      region: "Africa",
      latlng: [
        6.5,
        -9.5
      ],
      demonym: "Liberian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lr.svg",
      currencies: [
        {
          code: "LRD",
          name: "Liberian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Libya",
      nameRu: "Ливия",
      alpha2Code: "LY",
      alpha3Code: "LBY",
      callingCodes: [
        "218"
      ],
      capital: "Tripoli",
      region: "Africa",
      latlng: [
        25,
        17
      ],
      demonym: "Libyan",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ly.svg",
      currencies: [
        {
          code: "LYD",
          name: "Libyan dinar",
          symbol: "ل.د"
        }
      ]
    },
    {
      name: "Liechtenstein",
      nameRu: "Лихтенштейн",
      alpha2Code: "LI",
      alpha3Code: "LIE",
      callingCodes: [
        "423"
      ],
      capital: "Vaduz",
      region: "Europe",
      latlng: [
        47.26666666,
        9.53333333
      ],
      demonym: "Liechtensteiner",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/li.svg",
      currencies: [
        {
          code: "CHF",
          name: "Swiss franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Lithuania",
      nameRu: "Литва",
      alpha2Code: "LT",
      alpha3Code: "LTU",
      callingCodes: [
        "370"
      ],
      capital: "Vilnius",
      region: "Europe",
      latlng: [
        56,
        24
      ],
      demonym: "Lithuanian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Luxembourg",
      nameRu: "Люксембург",
      alpha2Code: "LU",
      alpha3Code: "LUX",
      callingCodes: [
        "352"
      ],
      capital: "Luxembourg",
      region: "Europe",
      latlng: [
        49.75,
        6.16666666
      ],
      demonym: "Luxembourger",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lu.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Macao",
      nameRu: "Аомынь (Макао)",
      alpha2Code: "MO",
      alpha3Code: "MAC",
      callingCodes: [
        "853"
      ],
      capital: null,
      region: "Asia",
      latlng: [
        22.16666666,
        113.55
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mo.svg",
      currencies: [
        {
          code: "MOP",
          name: "Macanese pataca",
          symbol: "P"
        }
      ]
    },
    {
      name: "North Macedonia",
      nameRu: "Македония",
      alpha2Code: "MK",
      alpha3Code: "MKD",
      callingCodes: [
        "389"
      ],
      capital: "Skopje",
      region: "Europe",
      latlng: [
        41.83333333,
        22
      ],
      demonym: "Macedonian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mk.svg",
      currencies: [
        {
          code: "MKD",
          name: "Macedonian denar",
          symbol: "ден"
        }
      ]
    },
    {
      name: "Madagascar",
      nameRu: "Мадагаскар",
      alpha2Code: "MG",
      alpha3Code: "MDG",
      callingCodes: [
        "261"
      ],
      capital: "Antananarivo",
      region: "Africa",
      latlng: [
        -20,
        47
      ],
      demonym: "Malagasy",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mg.svg",
      currencies: [
        {
          code: "MGA",
          name: "Malagasy ariary",
          symbol: "Ar"
        }
      ]
    },
    {
      name: "Malawi",
      nameRu: "Малави",
      alpha2Code: "MW",
      alpha3Code: "MWI",
      callingCodes: [
        "265"
      ],
      capital: "Lilongwe",
      region: "Africa",
      latlng: [
        -13.5,
        34
      ],
      demonym: "Malawian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mw.svg",
      currencies: [
        {
          code: "MWK",
          name: "Malawian kwacha",
          symbol: "MK"
        }
      ]
    },
    {
      name: "Malaysia",
      nameRu: "Малайзия",
      alpha2Code: "MY",
      alpha3Code: "MYS",
      callingCodes: [
        "60"
      ],
      capital: "Kuala Lumpur",
      region: "Asia",
      latlng: [
        2.5,
        112.5
      ],
      demonym: "Malaysian",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/my.svg",
      currencies: [
        {
          code: "MYR",
          name: "Malaysian ringgit",
          symbol: "RM"
        }
      ]
    },
    {
      name: "Maldives",
      nameRu: "Мальдивы",
      alpha2Code: "MV",
      alpha3Code: "MDV",
      callingCodes: [
        "960"
      ],
      capital: "Malé",
      region: "Asia",
      latlng: [
        3.25,
        73
      ],
      demonym: "Maldivan",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mv.svg",
      currencies: [
        {
          code: "MVR",
          name: "Maldivian rufiyaa",
          symbol: ".ރ"
        }
      ]
    },
    {
      name: "Mali",
      nameRu: "Мали",
      alpha2Code: "ML",
      alpha3Code: "MLI",
      callingCodes: [
        "223"
      ],
      capital: "Bamako",
      region: "Africa",
      latlng: [
        17,
        -4
      ],
      demonym: "Malian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ml.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Malta",
      nameRu: "Мальта",
      alpha2Code: "MT",
      alpha3Code: "MLT",
      callingCodes: [
        "356"
      ],
      capital: "Valletta",
      region: "Europe",
      latlng: [
        35.83333333,
        14.58333333
      ],
      demonym: "Maltese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Marshall Islands",
      nameRu: "Маршалловы Острова",
      alpha2Code: "MH",
      alpha3Code: "MHL",
      callingCodes: [
        "692"
      ],
      capital: "Majuro",
      region: "Oceania",
      latlng: [
        9,
        168
      ],
      demonym: "Marshallese",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mh.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Martinique",
      nameRu: "Мартиника",
      alpha2Code: "MQ",
      alpha3Code: "MTQ",
      callingCodes: [
        "596"
      ],
      capital: "Fort-de-France",
      region: "Americas",
      latlng: [
        14.666667,
        -61
      ],
      demonym: "French",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mq.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mauritania",
      nameRu: "Мавритания",
      alpha2Code: "MR",
      alpha3Code: "MRT",
      callingCodes: [
        "222"
      ],
      capital: "Nouakchott",
      region: "Africa",
      latlng: [
        20,
        -12
      ],
      demonym: "Mauritanian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mr.svg",
      currencies: [
        {
          code: "MRO",
          name: "Mauritanian ouguiya",
          symbol: "UM"
        }
      ]
    },
    {
      name: "Mauritius",
      nameRu: "Маврикий",
      alpha2Code: "MU",
      alpha3Code: "MUS",
      callingCodes: [
        "230"
      ],
      capital: "Port Louis",
      region: "Africa",
      latlng: [
        -20.28333333,
        57.55
      ],
      demonym: "Mauritian",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mu.svg",
      currencies: [
        {
          code: "MUR",
          name: "Mauritian rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Mayotte",
      nameRu: "Майотта (Маоре)",
      alpha2Code: "YT",
      alpha3Code: "MYT",
      callingCodes: [
        "262"
      ],
      capital: "Mamoudzou",
      region: "Africa",
      latlng: [
        -12.83333333,
        45.16666666
      ],
      demonym: "French",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/yt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mexico",
      nameRu: "Мексика",
      alpha2Code: "MX",
      alpha3Code: "MEX",
      callingCodes: [
        "52"
      ],
      capital: "Mexico City",
      region: "Americas",
      latlng: [
        23,
        -102
      ],
      demonym: "Mexican",
      timezones: [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mx.svg",
      currencies: [
        {
          code: "MXN",
          name: "Mexican peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Micronesia (Federated States of)",
      nameRu: "Микронезия",
      alpha2Code: "FM",
      alpha3Code: "FSM",
      callingCodes: [
        "691"
      ],
      capital: "Palikir",
      region: "Oceania",
      latlng: [
        6.91666666,
        158.25
      ],
      demonym: "Micronesian",
      timezones: [
        "UTC+10:00",
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fm.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Moldova (Republic of)",
      nameRu: "Молдавия (Молдова)",
      alpha2Code: "MD",
      alpha3Code: "MDA",
      callingCodes: [
        "373"
      ],
      capital: "Chișinău",
      region: "Europe",
      latlng: [
        47,
        29
      ],
      demonym: "Moldovan",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/md.svg",
      currencies: [
        {
          code: "MDL",
          name: "Moldovan leu",
          symbol: "L"
        }
      ]
    },
    {
      name: "Monaco",
      nameRu: "Монако",
      alpha2Code: "MC",
      alpha3Code: "MCO",
      callingCodes: [
        "377"
      ],
      capital: "Monaco",
      region: "Europe",
      latlng: [
        43.73333333,
        7.4
      ],
      demonym: "Monegasque",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mc.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mongolia",
      nameRu: "Монголия",
      alpha2Code: "MN",
      alpha3Code: "MNG",
      callingCodes: [
        "976"
      ],
      capital: "Ulan Bator",
      region: "Asia",
      latlng: [
        46,
        105
      ],
      demonym: "Mongolian",
      timezones: [
        "UTC+07:00",
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mn.svg",
      currencies: [
        {
          code: "MNT",
          name: "Mongolian tögrög",
          symbol: "₮"
        }
      ]
    },
    {
      name: "Montenegro",
      nameRu: "Монтенегро",
      alpha2Code: "ME",
      alpha3Code: "MNE",
      callingCodes: [
        "382"
      ],
      capital: "Podgorica",
      region: "Europe",
      latlng: [
        42.5,
        19.3
      ],
      demonym: "Montenegrin",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/me.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Montserrat",
      nameRu: "Монтсеррат",
      alpha2Code: "MS",
      alpha3Code: "MSR",
      callingCodes: [
        "1"
      ],
      capital: "Plymouth",
      region: "Americas",
      latlng: [
        16.75,
        -62.2
      ],
      demonym: "Montserratian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ms.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Morocco",
      nameRu: "Марокко",
      alpha2Code: "MA",
      alpha3Code: "MAR",
      callingCodes: [
        "212"
      ],
      capital: "Rabat",
      region: "Africa",
      latlng: [
        32,
        -5
      ],
      demonym: "Moroccan",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ma.svg",
      currencies: [
        {
          code: "MAD",
          name: "Moroccan dirham",
          symbol: "د.م."
        }
      ]
    },
    {
      name: "Mozambique",
      nameRu: "Мозамбик",
      alpha2Code: "MZ",
      alpha3Code: "MOZ",
      callingCodes: [
        "258"
      ],
      capital: "Maputo",
      region: "Africa",
      latlng: [
        -18.25,
        35
      ],
      demonym: "Mozambican",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mz.svg",
      currencies: [
        {
          code: "MZN",
          name: "Mozambican metical",
          symbol: "MT"
        }
      ]
    },
    {
      name: "Myanmar",
      nameRu: "Мьянма",
      alpha2Code: "MM",
      alpha3Code: "MMR",
      callingCodes: [
        "95"
      ],
      capital: "Naypyidaw",
      region: "Asia",
      latlng: [
        22,
        98
      ],
      demonym: "Burmese",
      timezones: [
        "UTC+06:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mm.svg",
      currencies: [
        {
          code: "MMK",
          name: "Burmese kyat",
          symbol: "Ks"
        }
      ]
    },
    {
      name: "Namibia",
      nameRu: "Намибия",
      alpha2Code: "NA",
      alpha3Code: "NAM",
      callingCodes: [
        "264"
      ],
      capital: "Windhoek",
      region: "Africa",
      latlng: [
        -22,
        17
      ],
      demonym: "Namibian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/na.svg",
      currencies: [
        {
          code: "NAD",
          name: "Namibian dollar",
          symbol: "$"
        },
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "Nauru",
      nameRu: "Науру",
      alpha2Code: "NR",
      alpha3Code: "NRU",
      callingCodes: [
        "674"
      ],
      capital: "Yaren",
      region: "Oceania",
      latlng: [
        -0.53333333,
        166.91666666
      ],
      demonym: "Nauruan",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nr.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Nepal",
      nameRu: "Непал",
      alpha2Code: "NP",
      alpha3Code: "NPL",
      callingCodes: [
        "977"
      ],
      capital: "Kathmandu",
      region: "Asia",
      latlng: [
        28,
        84
      ],
      demonym: "Nepalese",
      timezones: [
        "UTC+05:45"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/np.svg",
      currencies: [
        {
          code: "NPR",
          name: "Nepalese rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Netherlands",
      nameRu: "Нидерланды",
      alpha2Code: "NL",
      alpha3Code: "NLD",
      callingCodes: [
        "31"
      ],
      capital: "Amsterdam",
      region: "Europe",
      latlng: [
        52.5,
        5.75
      ],
      demonym: "Dutch",
      timezones: [
        "UTC-04:00",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nl.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "New Caledonia",
      nameRu: "Новая Каледония",
      alpha2Code: "NC",
      alpha3Code: "NCL",
      callingCodes: [
        "687"
      ],
      capital: "Nouméa",
      region: "Oceania",
      latlng: [
        -21.5,
        165.5
      ],
      demonym: "New Caledonian",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nc.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "New Zealand",
      nameRu: "Новая Зеландия",
      alpha2Code: "NZ",
      alpha3Code: "NZL",
      callingCodes: [
        "64"
      ],
      capital: "Wellington",
      region: "Oceania",
      latlng: [
        -41,
        174
      ],
      demonym: "New Zealander",
      timezones: [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00",
        "UTC+12:45",
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nz.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Nicaragua",
      nameRu: "Никарагуа",
      alpha2Code: "NI",
      alpha3Code: "NIC",
      callingCodes: [
        "505"
      ],
      capital: "Managua",
      region: "Americas",
      latlng: [
        13,
        -85
      ],
      demonym: "Nicaraguan",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ni.svg",
      currencies: [
        {
          code: "NIO",
          name: "Nicaraguan córdoba",
          symbol: "C$"
        }
      ]
    },
    {
      name: "Niger",
      nameRu: "Нигер",
      alpha2Code: "NE",
      alpha3Code: "NER",
      callingCodes: [
        "227"
      ],
      capital: "Niamey",
      region: "Africa",
      latlng: [
        16,
        8
      ],
      demonym: "Nigerien",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ne.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Nigeria",
      nameRu: "Нигерия",
      alpha2Code: "NG",
      alpha3Code: "NGA",
      callingCodes: [
        "234"
      ],
      capital: "Abuja",
      region: "Africa",
      latlng: [
        10,
        8
      ],
      demonym: "Nigerian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ng.svg",
      currencies: [
        {
          code: "NGN",
          name: "Nigerian naira",
          symbol: "₦"
        }
      ]
    },
    {
      name: "Niue",
      nameRu: "Ниуэ",
      alpha2Code: "NU",
      alpha3Code: "NIU",
      callingCodes: [
        "683"
      ],
      capital: "Alofi",
      region: "Oceania",
      latlng: [
        -19.03333333,
        -169.86666666
      ],
      demonym: "Niuean",
      timezones: [
        "UTC-11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nu.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "NZD",
          name: "Niue dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Norfolk Island",
      nameRu: "Норфолк",
      alpha2Code: "NF",
      alpha3Code: "NFK",
      callingCodes: [
        "672"
      ],
      capital: "Kingston",
      region: "Oceania",
      latlng: [
        -29.03333333,
        167.95
      ],
      demonym: "Norfolk Islander",
      timezones: [
        "UTC+11:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nf.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Korea (Democratic People's Republic of)",
      nameRu: "Корейская Народно-Демократическая Республика (КНДР)",
      alpha2Code: "KP",
      alpha3Code: "PRK",
      callingCodes: [
        "850"
      ],
      capital: "Pyongyang",
      region: "Asia",
      latlng: [
        40,
        127
      ],
      demonym: "North Korean",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kp.svg",
      currencies: [
        {
          code: "KPW",
          name: "North Korean won",
          symbol: "₩"
        }
      ]
    },
    {
      name: "Northern Mariana Islands",
      nameRu: "Марианские Острова",
      alpha2Code: "MP",
      alpha3Code: "MNP",
      callingCodes: [
        "1"
      ],
      capital: "Saipan",
      region: "Oceania",
      latlng: [
        15.2,
        145.75
      ],
      demonym: "American",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mp.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Norway",
      nameRu: "Норвения",
      alpha2Code: "NO",
      alpha3Code: "NOR",
      callingCodes: [
        "47"
      ],
      capital: "Oslo",
      region: "Europe",
      latlng: [
        62,
        10
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/no.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Oman",
      nameRu: "Оман",
      alpha2Code: "OM",
      alpha3Code: "OMN",
      callingCodes: [
        "968"
      ],
      capital: "Muscat",
      region: "Asia",
      latlng: [
        21,
        57
      ],
      demonym: "Omani",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/om.svg",
      currencies: [
        {
          code: "OMR",
          name: "Omani rial",
          symbol: "ر.ع."
        }
      ]
    },
    {
      name: "Pakistan",
      nameRu: "Пакистан",
      alpha2Code: "PK",
      alpha3Code: "PAK",
      callingCodes: [
        "92"
      ],
      capital: "Islamabad",
      region: "Asia",
      latlng: [
        30,
        70
      ],
      demonym: "Pakistani",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pk.svg",
      currencies: [
        {
          code: "PKR",
          name: "Pakistani rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Palau",
      nameRu: "Палау",
      alpha2Code: "PW",
      alpha3Code: "PLW",
      callingCodes: [
        "680"
      ],
      capital: "Ngerulmud",
      region: "Oceania",
      latlng: [
        7.5,
        134.5
      ],
      demonym: "Palauan",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pw.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Palestine, State of",
      nameRu: "Палестина",
      alpha2Code: "PS",
      alpha3Code: "PSE",
      callingCodes: [
        "970"
      ],
      capital: "Ramallah",
      region: "Asia",
      latlng: [
        31.9,
        35.2
      ],
      demonym: "Palestinian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ps.svg",
      currencies: [
        {
          code: "EGP",
          name: "Egyptian pound",
          symbol: "E£"
        },
        {
          code: "ILS",
          name: "Israeli new shekel",
          symbol: "₪"
        },
        {
          code: "JOD",
          name: "Jordanian dinar",
          symbol: "د.أ"
        }
      ]
    },
    {
      name: "Panama",
      nameRu: "Панама",
      alpha2Code: "PA",
      alpha3Code: "PAN",
      callingCodes: [
        "507"
      ],
      capital: "Panama City",
      region: "Americas",
      latlng: [
        9,
        -80
      ],
      demonym: "Panamanian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pa.svg",
      currencies: [
        {
          code: "PAB",
          name: "Panamanian balboa",
          symbol: "B/."
        },
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Papua New Guinea",
      nameRu: "Папуа - Новая Гвинея",
      alpha2Code: "PG",
      alpha3Code: "PNG",
      callingCodes: [
        "675"
      ],
      capital: "Port Moresby",
      region: "Oceania",
      latlng: [
        -6,
        147
      ],
      demonym: "Papua New Guinean",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pg.svg",
      currencies: [
        {
          code: "PGK",
          name: "Papua New Guinean kina",
          symbol: "K"
        }
      ]
    },
    {
      name: "Paraguay",
      nameRu: "Парагвай",
      alpha2Code: "PY",
      alpha3Code: "PRY",
      callingCodes: [
        "595"
      ],
      capital: "Asunción",
      region: "Americas",
      latlng: [
        -23,
        -58
      ],
      demonym: "Paraguayan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/py.svg",
      currencies: [
        {
          code: "PYG",
          name: "Paraguayan guaraní",
          symbol: "₲"
        }
      ]
    },
    {
      name: "Peru",
      nameRu: "Перу",
      alpha2Code: "PE",
      alpha3Code: "PER",
      callingCodes: [
        "51"
      ],
      capital: "Lima",
      region: "Americas",
      latlng: [
        -10,
        -76
      ],
      demonym: "Peruvian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pe.svg",
      currencies: [
        {
          code: "PEN",
          name: "Peruvian sol",
          symbol: "S/."
        }
      ]
    },
    {
      name: "Philippines",
      nameRu: "Филиппины",
      alpha2Code: "PH",
      alpha3Code: "PHL",
      callingCodes: [
        "63"
      ],
      capital: "Manila",
      region: "Asia",
      latlng: [
        13,
        122
      ],
      demonym: "Filipino",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ph.svg",
      currencies: [
        {
          code: "PHP",
          name: "Philippine peso",
          symbol: "₱"
        }
      ]
    },
    {
      name: "Pitcairn",
      nameRu: "Питкэрн",
      alpha2Code: "PN",
      alpha3Code: "PCN",
      callingCodes: [
        "64"
      ],
      capital: "Adamstown",
      region: "Oceania",
      latlng: [
        -25.06666666,
        -130.1
      ],
      demonym: "Pitcairn Islander",
      timezones: [
        "UTC-08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pn.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "PND",
          name: "Pitcairn Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Poland",
      nameRu: "Польша",
      alpha2Code: "PL",
      alpha3Code: "POL",
      callingCodes: [
        "48"
      ],
      capital: "Warsaw",
      region: "Europe",
      latlng: [
        52,
        20
      ],
      demonym: "Polish",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pl.svg",
      currencies: [
        {
          code: "PLN",
          name: "Polish złoty",
          symbol: "zł"
        }
      ]
    },
    {
      name: "Portugal",
      nameRu: "Португалия",
      alpha2Code: "PT",
      alpha3Code: "PRT",
      callingCodes: [
        "351"
      ],
      capital: "Lisbon",
      region: "Europe",
      latlng: [
        39.5,
        -8
      ],
      demonym: "Portuguese",
      timezones: [
        "UTC-01:00",
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Puerto Rico",
      nameRu: "Пуэрто-Рико",
      alpha2Code: "PR",
      alpha3Code: "PRI",
      callingCodes: [
        "1"
      ],
      capital: "San Juan",
      region: "Americas",
      latlng: [
        18.25,
        -66.5
      ],
      demonym: "Puerto Rican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pr.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Qatar",
      nameRu: "Катар",
      alpha2Code: "QA",
      alpha3Code: "QAT",
      callingCodes: [
        "974"
      ],
      capital: "Doha",
      region: "Asia",
      latlng: [
        25.5,
        51.25
      ],
      demonym: "Qatari",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/qa.svg",
      currencies: [
        {
          code: "QAR",
          name: "Qatari riyal",
          symbol: "ر.ق"
        }
      ]
    },
    // {
    //   name: "Republic of Kosovo",
    //   alpha2Code: "XK",
    //   alpha3Code: "UNK",
    //   callingCodes: [
    //     "383"
    //   ],
    //   capital: "Pristina",
    //   region: "Europe",
    //   latlng: [
    //     42.666667,
    //     21.166667
    //   ],
    //   demonym: "Kosovar",
    //   timezones: [
    //     "UTC+01:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/xk.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Réunion",
      nameRu: "Реюньон",
      alpha2Code: "RE",
      alpha3Code: "REU",
      callingCodes: [
        "262"
      ],
      capital: "Saint-Denis",
      region: "Africa",
      latlng: [
        -21.15,
        55.5
      ],
      demonym: "French",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/re.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Romania",
      nameRu: "Румыния",
      alpha2Code: "RO",
      alpha3Code: "ROU",
      callingCodes: [
        "40"
      ],
      capital: "Bucharest",
      region: "Europe",
      latlng: [
        46,
        25
      ],
      demonym: "Romanian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ro.svg",
      currencies: [
        {
          code: "RON",
          name: "Romanian leu",
          symbol: "lei"
        }
      ]
    },
    {
      name: "Russian Federation",
      nameRu: "Российская Федерация",
      alpha2Code: "RU",
      alpha3Code: "RUS",
      callingCodes: [
        "7"
      ],
      capital: "Moscow",
      region: "Europe",
      latlng: [
        60,
        100
      ],
      demonym: "Russian",
      timezones: [
        "UTC+03:00",
        "UTC+04:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ru.svg",
      currencies: [
        {
          code: "RUB",
          name: "Russian ruble",
          symbol: "₽"
        }
      ]
    },
    {
      name: "Rwanda",
      nameRu: "Руанда",
      alpha2Code: "RW",
      alpha3Code: "RWA",
      callingCodes: [
        "250"
      ],
      capital: "Kigali",
      region: "Africa",
      latlng: [
        -2,
        30
      ],
      demonym: "Rwandan",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/rw.svg",
      currencies: [
        {
          code: "RWF",
          name: "Rwandan franc",
          symbol: "Fr"
        }
      ]
    },
    // {
    //   name: "Saint Barthélemy",
    //   alpha2Code: "BL",
    //   alpha3Code: "BLM",
    //   callingCodes: [
    //     "590"
    //   ],
    //   capital: "Gustavia",
    //   region: "Americas",
    //   latlng: [
    //     18.5,
    //     -63.41666666
    //   ],
    //   demonym: "Saint Barthélemy Islander",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/bl.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      nameRu: "Остров Святой Елены",
      alpha2Code: "SH",
      alpha3Code: "SHN",
      callingCodes: [
        "290"
      ],
      capital: "Jamestown",
      region: "Africa",
      latlng: [
        -15.95,
        -5.7
      ],
      demonym: "Saint Helenian",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sh.svg",
      currencies: [
        {
          code: "SHP",
          name: "Saint Helena pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Saint Kitts and Nevis",
      nameRu: "Сент-Китс и Невис",
      alpha2Code: "KN",
      alpha3Code: "KNA",
      callingCodes: [
        "1"
      ],
      capital: "Basseterre",
      region: "Americas",
      latlng: [
        17.33333333,
        -62.75
      ],
      demonym: "Kittian and Nevisian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kn.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Saint Lucia",
      nameRu: "Сент-Люсия",
      alpha2Code: "LC",
      alpha3Code: "LCA",
      callingCodes: [
        "1"
      ],
      capital: "Castries",
      region: "Americas",
      latlng: [
        13.88333333,
        -60.96666666
      ],
      demonym: "Saint Lucian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lc.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    // {
    //   name: "Saint Martin (French part)",
    //   alpha2Code: "MF",
    //   alpha3Code: "MAF",
    //   callingCodes: [
    //     "590"
    //   ],
    //   capital: "Marigot",
    //   region: "Americas",
    //   latlng: [
    //     18.08333333,
    //     -63.95
    //   ],
    //   demonym: "Saint Martin Islander",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/mf.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Saint Pierre and Miquelon",
      nameRu: "Сен-Пьер и Микелон",
      alpha2Code: "PM",
      alpha3Code: "SPM",
      callingCodes: [
        "508"
      ],
      capital: "Saint-Pierre",
      region: "Americas",
      latlng: [
        46.83333333,
        -56.33333333
      ],
      demonym: "French",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pm.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Saint Vincent and the Grenadines",
      nameRu: "Сент-Винсент и Гренадины",
      alpha2Code: "VC",
      alpha3Code: "VCT",
      callingCodes: [
        "1"
      ],
      capital: "Kingstown",
      region: "Americas",
      latlng: [
        13.25,
        -61.2
      ],
      demonym: "Saint Vincentian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vc.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Samoa",
      nameRu: "Западное Самоа",
      alpha2Code: "WS",
      alpha3Code: "WSM",
      callingCodes: [
        "685"
      ],
      capital: "Apia",
      region: "Oceania",
      latlng: [
        -13.58333333,
        -172.33333333
      ],
      demonym: "Samoan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ws.svg",
      currencies: [
        {
          code: "WST",
          name: "Samoan tālā",
          symbol: "T"
        }
      ]
    },
    { 
      name: "San Marino",
      nameRu: "Сан-Марино",
      alpha2Code: "SM",
      alpha3Code: "SMR",
      callingCodes: [
        "378"
      ],
      capital: "City of San Marino",
      region: "Europe",
      latlng: [
        43.76666666,
        12.41666666
      ],
      demonym: "Sammarinese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sm.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Sao Tome and Principe",
      nameRu: "Сан-Томе и Принсипе",
      alpha2Code: "ST",
      alpha3Code: "STP",
      callingCodes: [
        "239"
      ],
      capital: "São Tomé",
      region: "Africa",
      latlng: [
        1,
        7
      ],
      demonym: "Sao Tomean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/st.svg",
      currencies: [
        {
          code: "STD",
          name: "São Tomé and Príncipe dobra",
          symbol: "Db"
        }
      ]
    },
    {
      name: "Saudi Arabia",
      nameRu: "Саудовская Аравия",
      alpha2Code: "SA",
      alpha3Code: "SAU",
      callingCodes: [
        "966"
      ],
      capital: "Riyadh",
      region: "Asia",
      latlng: [
        25,
        45
      ],
      demonym: "Saudi Arabian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sa.svg",
      currencies: [
        {
          code: "SAR",
          name: "Saudi riyal",
          symbol: "ر.س"
        }
      ]
    },
    {
      name: "Senegal",
      nameRu: "Сенегал",
      alpha2Code: "SN",
      alpha3Code: "SEN",
      callingCodes: [
        "221"
      ],
      capital: "Dakar",
      region: "Africa",
      latlng: [
        14,
        -14
      ],
      demonym: "Senegalese",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sn.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Serbia",
      nameRu: "Сербия",
      alpha2Code: "RS",
      alpha3Code: "SRB",
      callingCodes: [
        "381"
      ],
      capital: "Belgrade",
      region: "Europe",
      latlng: [
        44,
        21
      ],
      demonym: "Serbian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/rs.svg",
      currencies: [
        {
          code: "RSD",
          name: "Serbian dinar",
          symbol: "дин."
        }
      ]
    },
    {
      name: "Seychelles",
      nameRu: "Сейшельские Острова",
      alpha2Code: "SC",
      alpha3Code: "SYC",
      callingCodes: [
        "248"
      ],
      capital: "Victoria",
      region: "Africa",
      latlng: [
        -4.58333333,
        55.66666666
      ],
      demonym: "Seychellois",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sc.svg",
      currencies: [
        {
          code: "SCR",
          name: "Seychellois rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Sierra Leone",
      nameRu: "Сьерра-Леоне",
      alpha2Code: "SL",
      alpha3Code: "SLE",
      callingCodes: [
        "232"
      ],
      capital: "Freetown",
      region: "Africa",
      latlng: [
        8.5,
        -11.5
      ],
      demonym: "Sierra Leonean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sl.svg",
      currencies: [
        {
          code: "SLL",
          name: "Sierra Leonean leone",
          symbol: "Le"
        }
      ]
    },
    {
      name: "Singapore",
      nameRu: "Сингапур",
      alpha2Code: "SG",
      alpha3Code: "SGP",
      callingCodes: [
        "65"
      ],
      capital: "Singapore",
      region: "Asia",
      latlng: [
        1.36666666,
        103.8
      ],
      demonym: "Singaporean",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sg.svg",
      currencies: [
        {
          code: "SGD",
          name: "Singapore dollar",
          symbol: "$"
        }
      ]
    },
    // {
    //   name: "Sint Maarten (Dutch part)",
    //   alpha2Code: "SX",
    //   alpha3Code: "SXM",
    //   callingCodes: [
    //     "1"
    //   ],
    //   capital: "Philipsburg",
    //   region: "Americas",
    //   latlng: [
    //     18.033333,
    //     -63.05
    //   ],
    //   demonym: "Dutch",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/sx.svg",
    //   currencies: [
    //     {
    //       code: "ANG",
    //       name: "Netherlands Antillean guilder",
    //       symbol: "ƒ"
    //     }
    //   ]
    // },
    {
      name: "Slovakia",
      nameRu: "Словакия",
      alpha2Code: "SK",
      alpha3Code: "SVK",
      callingCodes: [
        "421"
      ],
      capital: "Bratislava",
      region: "Europe",
      latlng: [
        48.66666666,
        19.5
      ],
      demonym: "Slovak",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sk.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Slovenia",
      nameRu: "Словения",
      alpha2Code: "SI",
      alpha3Code: "SVN",
      callingCodes: [
        "386"
      ],
      capital: "Ljubljana",
      region: "Europe",
      latlng: [
        46.11666666,
        14.81666666
      ],
      demonym: "Slovene",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/si.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Solomon Islands",
      nameRu: "Соломоновы Острова",
      alpha2Code: "SB",
      alpha3Code: "SLB",
      callingCodes: [
        "677"
      ],
      capital: "Honiara",
      region: "Oceania",
      latlng: [
        -8,
        159
      ],
      demonym: "Solomon Islander",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sb.svg",
      currencies: [
        {
          code: "SBD",
          name: "Solomon Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Somalia",
      nameRu: "Сомали",
      alpha2Code: "SO",
      alpha3Code: "SOM",
      callingCodes: [
        "252"
      ],
      capital: "Mogadishu",
      region: "Africa",
      latlng: [
        10,
        49
      ],
      demonym: "Somali",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/so.svg",
      currencies: [
        {
          code: "SOS",
          name: "Somali shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "South Africa",
      nameRu: "Южно-Африканская Республика",
      alpha2Code: "ZA",
      alpha3Code: "ZAF",
      callingCodes: [
        "27"
      ],
      capital: "Pretoria",
      region: "Africa",
      latlng: [
        -29,
        24
      ],
      demonym: "South African",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/za.svg",
      currencies: [
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      nameRu: "Южная Георгия и Южные Сандвичевы Острова",
      alpha2Code: "GS",
      alpha3Code: "SGS",
      callingCodes: [
        "500"
      ],
      capital: "King Edward Point",
      region: "Americas",
      latlng: [
        -54.5,
        -37
      ],
      demonym: "South Georgia and the South Sandwich Islander",
      timezones: [
        "UTC-02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gs.svg",
      currencies: [
        {
          code: "FKP",
          name: "Falkland Islands Pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Korea (Republic of)",
      nameRu: "Корея, Республика",
      alpha2Code: "KR",
      alpha3Code: "KOR",
      callingCodes: [
        "82"
      ],
      capital: "Seoul",
      region: "Asia",
      latlng: [
        37,
        127.5
      ],
      demonym: "South Korean",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kr.svg",
      currencies: [
        {
          code: "KRW",
          name: "South Korean won",
          symbol: "₩"
        }
      ]
    },
    {
      name: "Spain",
      nameRu: "Испания",
      alpha2Code: "ES",
      alpha3Code: "ESP",
      callingCodes: [
        "34"
      ],
      capital: "Madrid",
      region: "Europe",
      latlng: [
        40,
        -4
      ],
      demonym: "Spanish",
      timezones: [
        "UTC",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/es.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Sri Lanka",
      nameRu: "Шри-Ланка",
      alpha2Code: "LK",
      alpha3Code: "LKA",
      callingCodes: [
        "94"
      ],
      capital: "Sri Jayawardenepura Kotte",
      region: "Asia",
      latlng: [
        7,
        81
      ],
      demonym: "Sri Lankan",
      timezones: [
        "UTC+05:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lk.svg",
      currencies: [
        {
          code: "LKR",
          name: "Sri Lankan rupee",
          symbol: "Rs"
        }
      ]
    },
    {
      name: "Sudan",
      nameRu: "Судан",
      alpha2Code: "SD",
      alpha3Code: "SDN",
      callingCodes: [
        "249"
      ],
      capital: "Khartoum",
      region: "Africa",
      latlng: [
        15,
        30
      ],
      demonym: "Sudanese",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sd.svg",
      currencies: [
        {
          code: "SDG",
          name: "Sudanese pound",
          symbol: "ج.س."
        }
      ]
    },
    // {
    //   name: "South Sudan",
    //   alpha2Code: "SS",
    //   alpha3Code: "SSD",
    //   callingCodes: [
    //     "211"
    //   ],
    //   capital: "Juba",
    //   region: "Africa",
    //   latlng: [
    //     7,
    //     30
    //   ],
    //   demonym: "South Sudanese",
    //   timezones: [
    //     "UTC+03:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/ss.svg",
    //   currencies: [
    //     {
    //       code: "SSP",
    //       name: "South Sudanese pound",
    //       symbol: "£"
    //     }
    //   ]
    // },
    {
      name: "Suriname",
      nameRu: "Суринам",
      alpha2Code: "SR",
      alpha3Code: "SUR",
      callingCodes: [
        "597"
      ],
      capital: "Paramaribo",
      region: "Americas",
      latlng: [
        4,
        -56
      ],
      demonym: "Surinamer",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sr.svg",
      currencies: [
        {
          code: "SRD",
          name: "Surinamese dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Svalbard and Jan Mayen",
      nameRu: "Свальбард и Ян Майен",
      alpha2Code: "SJ",
      alpha3Code: "SJM",
      callingCodes: [
        "47"
      ],
      capital: "Longyearbyen",
      region: "Europe",
      latlng: [
        78,
        20
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sj.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Swaziland",
      nameRu: "Свазиленд",
      alpha2Code: "SZ",
      alpha3Code: "SWZ",
      callingCodes: [
        "268"
      ],
      capital: "Mbabane",
      region: "Africa",
      latlng: [
        -26.5,
        31.5
      ],
      demonym: "Swazi",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sz.svg",
      currencies: [
        {
          code: "SZL",
          name: "Swazi lilangeni",
          symbol: "L"
        }
      ]
    },
    {
      name: "Sweden",
      nameRu: "Швеция",
      alpha2Code: "SE",
      alpha3Code: "SWE",
      callingCodes: [
        "46"
      ],
      capital: "Stockholm",
      region: "Europe",
      latlng: [
        62,
        15
      ],
      demonym: "Swedish",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/se.svg",
      currencies: [
        {
          code: "SEK",
          name: "Swedish krona",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Switzerland",
      nameRu: "Швейцария",
      alpha2Code: "CH",
      alpha3Code: "CHE",
      callingCodes: [
        "41"
      ],
      capital: "Bern",
      region: "Europe",
      latlng: [
        47,
        8
      ],
      demonym: "Swiss",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ch.svg",
      currencies: [
        {
          code: "CHF",
          name: "Swiss franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Syrian Arab Republic",
      nameRu: "Сирия",
      alpha2Code: "SY",
      alpha3Code: "SYR",
      callingCodes: [
        "963"
      ],
      capital: "Damascus",
      region: "Asia",
      latlng: [
        35,
        38
      ],
      demonym: "Syrian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sy.svg",
      currencies: [
        {
          code: "SYP",
          name: "Syrian pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Taiwan",
      nameRu: "Тайвань",
      alpha2Code: "TW",
      alpha3Code: "TWN",
      callingCodes: [
        "886"
      ],
      capital: "Taipei",
      region: "Asia",
      latlng: [
        23.5,
        121
      ],
      demonym: "Taiwanese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tw.svg",
      currencies: [
        {
          code: "TWD",
          name: "New Taiwan dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tajikistan",
      nameRu: "Таджикистан",
      alpha2Code: "TJ",
      alpha3Code: "TJK",
      callingCodes: [
        "992"
      ],
      capital: "Dushanbe",
      region: "Asia",
      latlng: [
        39,
        71
      ],
      demonym: "Tadzhik",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tj.svg",
      currencies: [
        {
          code: "TJS",
          name: "Tajikistani somoni",
          symbol: "ЅМ"
        }
      ]
    },
    {
      name: "Tanzania, United Republic of",
      nameRu: "Танзания",
      alpha2Code: "TZ",
      alpha3Code: "TZA",
      callingCodes: [
        "255"
      ],
      capital: "Dodoma",
      region: "Africa",
      latlng: [
        -6,
        35
      ],
      demonym: "Tanzanian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tz.svg",
      currencies: [
        {
          code: "TZS",
          name: "Tanzanian shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Thailand",
      nameRu: "Таиланд",
      alpha2Code: "TH",
      alpha3Code: "THA",
      callingCodes: [
        "66"
      ],
      capital: "Bangkok",
      region: "Asia",
      latlng: [
        15,
        100
      ],
      demonym: "Thai",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/th.svg",
      currencies: [
        {
          code: "THB",
          name: "Thai baht",
          symbol: "฿"
        }
      ]
    },
    // {
    //   name: "Timor-Leste",
    //   alpha2Code: "TL",
    //   alpha3Code: "TLS",
    //   callingCodes: [
    //     "670"
    //   ],
    //   capital: "Dili",
    //   region: "Asia",
    //   latlng: [
    //     -8.83333333,
    //     125.91666666
    //   ],
    //   demonym: "East Timorese",
    //   timezones: [
    //     "UTC+09:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/tl.svg",
    //   currencies: [
    //     {
    //       code: "USD",
    //       name: "United States Dollar",
    //       symbol: "$"
    //     }
    //   ]
    // },
    {
      name: "Togo",
      nameRu: "Того",
      alpha2Code: "TG",
      alpha3Code: "TGO",
      callingCodes: [
        "228"
      ],
      capital: "Lomé",
      region: "Africa",
      latlng: [
        8,
        1.16666666
      ],
      demonym: "Togolese",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tg.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Tokelau",
      nameRu: "Токелау",
      alpha2Code: "TK",
      alpha3Code: "TKL",
      callingCodes: [
        "690"
      ],
      capital: "Fakaofo",
      region: "Oceania",
      latlng: [
        -9,
        -172
      ],
      demonym: "Tokelauan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tk.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tonga",
      nameRu: "Тонга",
      alpha2Code: "TO",
      alpha3Code: "TON",
      callingCodes: [
        "676"
      ],
      capital: "Nuku'alofa",
      region: "Oceania",
      latlng: [
        -20,
        -175
      ],
      demonym: "Tongan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/to.svg",
      currencies: [
        {
          code: "TOP",
          name: "Tongan paʻanga",
          symbol: "T$"
        }
      ]
    },
    {
      name: "Trinidad and Tobago",
      nameRu: "Тринидад и Тобаго",
      alpha2Code: "TT",
      alpha3Code: "TTO",
      callingCodes: [
        "1"
      ],
      capital: "Port of Spain",
      region: "Americas",
      latlng: [
        11,
        -61
      ],
      demonym: "Trinidadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tt.svg",
      currencies: [
        {
          code: "TTD",
          name: "Trinidad and Tobago dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tunisia",
      nameRu: "Тунис",
      alpha2Code: "TN",
      alpha3Code: "TUN",
      callingCodes: [
        "216"
      ],
      capital: "Tunis",
      region: "Africa",
      latlng: [
        34,
        9
      ],
      demonym: "Tunisian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tn.svg",
      currencies: [
        {
          code: "TND",
          name: "Tunisian dinar",
          symbol: "د.ت"
        }
      ]
    },
    {
      name: "Turkey",
      nameRu: "Турция",
      alpha2Code: "TR",
      alpha3Code: "TUR",
      callingCodes: [
        "90"
      ],
      capital: "Ankara",
      region: "Asia",
      latlng: [
        39,
        35
      ],
      demonym: "Turkish",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tr.svg",
      currencies: [
        {
          code: "TRY",
          name: "Turkish lira",
          symbol: "₺"
        }
      ]
    },
    {
      name: "Turkmenistan",
      nameRu: "Туркменистан",
      alpha2Code: "TM",
      alpha3Code: "TKM",
      callingCodes: [
        "993"
      ],
      capital: "Ashgabat",
      region: "Asia",
      latlng: [
        40,
        60
      ],
      demonym: "Turkmen",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tm.svg",
      currencies: [
        {
          code: "TMT",
          name: "Turkmenistan manat",
          symbol: "m"
        }
      ]
    },
    {
      name: "Turks and Caicos Islands",
      nameRu: "Теркс и Кайкос",
      alpha2Code: "TC",
      alpha3Code: "TCA",
      callingCodes: [
        "1"
      ],
      capital: "Cockburn Town",
      region: "Americas",
      latlng: [
        21.75,
        -71.58333333
      ],
      demonym: "Turks and Caicos Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tc.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tuvalu",
      nameRu: "Тувалу",
      alpha2Code: "TV",
      alpha3Code: "TUV",
      callingCodes: [
        "688"
      ],
      capital: "Funafuti",
      region: "Oceania",
      latlng: [
        -8,
        178
      ],
      demonym: "Tuvaluan",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tv.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        },
        {
          code: "TVD[G]",
          name: "Tuvaluan dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uganda",
      nameRu: "Уганда",
      alpha2Code: "UG",
      alpha3Code: "UGA",
      callingCodes: [
        "256"
      ],
      capital: "Kampala",
      region: "Africa",
      latlng: [
        1,
        32
      ],
      demonym: "Ugandan",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ug.svg",
      currencies: [
        {
          code: "UGX",
          name: "Ugandan shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Ukraine",
      nameRu: "Украина",
      alpha2Code: "UA",
      alpha3Code: "UKR",
      callingCodes: [
        "380"
      ],
      capital: "Kyiv",
      region: "Europe",
      latlng: [
        49,
        32
      ],
      demonym: "Ukrainian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ua.svg",
      currencies: [
        {
          code: "UAH",
          name: "Ukrainian hryvnia",
          symbol: "₴"
        }
      ]
    },
    {
      name: "United Arab Emirates",
      nameRu: "Объединенные Арабские Эмираты",
      alpha2Code: "AE",
      alpha3Code: "ARE",
      callingCodes: [
        "971"
      ],
      capital: "Abu Dhabi",
      region: "Asia",
      latlng: [
        24,
        54
      ],
      demonym: "Emirati",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ae.svg",
      currencies: [
        {
          code: "AED",
          name: "United Arab Emirates dirham",
          symbol: "د.إ"
        }
      ]
    },
    {
      name: "United Kingdom of Great Britain and Northern Ireland",
      nameRu: "Великобритания",
      alpha2Code: "GB",
      alpha3Code: "GBR",
      callingCodes: [
        "44"
      ],
      capital: "London",
      region: "Europe",
      latlng: [
        54,
        -2
      ],
      demonym: "British",
      timezones: [
        "UTC-08:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00",
        "UTC",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gb.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "United States of America",
      nameRu: "Соединенные Штаты Америки (США)",
      alpha2Code: "US",
      alpha3Code: "USA",
      callingCodes: [
        "1"
      ],
      capital: "Washington, D.C.",
      region: "Americas",
      latlng: [
        38,
        -97
      ],
      demonym: "American",
      timezones: [
        "UTC-12:00",
        "UTC-11:00",
        "UTC-10:00",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/us.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uruguay",
      nameRu: "Уругвай",
      alpha2Code: "UY",
      alpha3Code: "URY",
      callingCodes: [
        "598"
      ],
      capital: "Montevideo",
      region: "Americas",
      latlng: [
        -33,
        -56
      ],
      demonym: "Uruguayan",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/uy.svg",
      currencies: [
        {
          code: "UYU",
          name: "Uruguayan peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uzbekistan",
      nameRu: "Узбекистан",
      alpha2Code: "UZ",
      alpha3Code: "UZB",
      callingCodes: [
        "998"
      ],
      capital: "Tashkent",
      region: "Asia",
      latlng: [
        41,
        64
      ],
      demonym: "Uzbekistani",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/uz.svg",
      currencies: [
        {
          code: "UZS",
          name: "Uzbekistani so'm",
          symbol: "so'm"
        }
      ]
    },
    {
      name: "Vanuatu",
      nameRu: "Вануату",
      alpha2Code: "VU",
      alpha3Code: "VUT",
      callingCodes: [
        "678"
      ],
      capital: "Port Vila",
      region: "Oceania",
      latlng: [
        -16,
        167
      ],
      demonym: "Ni-Vanuatu",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vu.svg",
      currencies: [
        {
          code: "VUV",
          name: "Vanuatu vatu",
          symbol: "Vt"
        }
      ]
    },
    {
      name: "Venezuela (Bolivarian Republic of)",
      nameRu: "Венесуэла",
      alpha2Code: "VE",
      alpha3Code: "VEN",
      callingCodes: [
        "58"
      ],
      capital: "Caracas",
      region: "Americas",
      latlng: [
        8,
        -66
      ],
      demonym: "Venezuelan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ve.svg",
      currencies: [
        {
          code: "VEF",
          name: "Venezuelan bolívar",
          symbol: "Bs S"
        }
      ]
    },
    {
      name: "Vietnam",
      nameRu: "Вьетнам",
      alpha2Code: "VN",
      alpha3Code: "VNM",
      callingCodes: [
        "84"
      ],
      capital: "Hanoi",
      region: "Asia",
      latlng: [
        16.16666666,
        107.83333333
      ],
      demonym: "Vietnamese",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vn.svg",
      currencies: [
        {
          code: "VND",
          name: "Vietnamese đồng",
          symbol: "₫"
        }
      ]
    },
    {
      name: "Wallis and Futuna",
      nameRu: "Уоллис и Футуна",
      alpha2Code: "WF",
      alpha3Code: "WLF",
      callingCodes: [
        "681"
      ],
      capital: "Mata-Utu",
      region: "Oceania",
      latlng: [
        -13.3,
        -176.2
      ],
      demonym: "Wallis and Futuna Islander",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/wf.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Western Sahara",
      nameRu: "Западная Сахара",
      alpha2Code: "EH",
      alpha3Code: "ESH",
      callingCodes: [
        "212"
      ],
      capital: "El Aaiún",
      region: "Africa",
      latlng: [
        24.5,
        -13
      ],
      demonym: "Sahrawi",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/eh.svg",
      currencies: [
        {
          code: "MAD",
          name: "Moroccan dirham",
          symbol: "د.م."
        },
        {
          code: "DZD",
          name: "Algerian dinar",
          symbol: "د.ج"
        }
      ]
    },
    {
      name: "Yemen",
      nameRu: "Йемен",
      alpha2Code: "YE",
      alpha3Code: "YEM",
      callingCodes: [
        "967"
      ],
      capital: "Sana'a",
      region: "Asia",
      latlng: [
        15,
        48
      ],
      demonym: "Yemeni",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ye.svg",
      currencies: [
        {
          code: "YER",
          name: "Yemeni rial",
          symbol: "﷼"
        }
      ]
    },
    {
      name: "Zambia",
      nameRu: "Замбия",
      alpha2Code: "ZM",
      alpha3Code: "ZMB",
      callingCodes: [
        "260"
      ],
      capital: "Lusaka",
      region: "Africa",
      latlng: [
        -15,
        30
      ],
      demonym: "Zambian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/zm.svg",
      currencies: [
        {
          code: "ZMW",
          name: "Zambian kwacha",
          symbol: "ZK"
        }
      ]
    },
    {
      name: "Zimbabwe",
      nameRu: "Зимбабве",
      alpha2Code: "ZW",
      alpha3Code: "ZWE",
      callingCodes: [
        "263"
      ],
      capital: "Harare",
      region: "Africa",
      latlng: [
        -20,
        30
      ],
      demonym: "Zimbabwean",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/zw.svg",
      currencies: [
        {
          code: "ZMW",
          name: "Zambian kwacha",
          symbol: "K"
        }
      ]
    }
  ]

export default CountriesListconst CountriesList = [
    {
      name: "Afghanistan",
      nameRu: "Афганистан",
      alpha2Code: "AF",
      alpha3Code: "AFG",
      callingCodes: [
        "93"
      ],
      capital: "Kabul",
      region: "Asia",
      latlng: [
        33,
        65
      ],
      demonym: "Afghan",
      timezones: [
        "UTC+04:30"
      ],
      flag: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg",
      currencies: [
        {
          code: "AFN",
          name: "Afghan afghani",
          symbol: "؋"
        }
      ]
    },
    {
      name: "Åland Islands",
      nameRu: "Аландские Острова",
      alpha2Code: "AX",
      alpha3Code: "ALA",
      callingCodes: [
        "358"
      ],
      capital: "Mariehamn",
      region: "Europe",
      latlng: [
        60.116667,
        19.9
      ],
      demonym: "Ålandish",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ax.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Albania",
      nameRu: "Албания",
      alpha2Code: "AL",
      alpha3Code: "ALB",
      callingCodes: [
        "355"
      ],
      capital: "Tirana",
      region: "Europe",
      latlng: [
        41,
        20
      ],
      demonym: "Albanian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/al.svg",
      currencies: [
        {
          code: "ALL",
          name: "Albanian lek",
          symbol: "L"
        }
      ]
    },
    {
      name: "Algeria",
      nameRu: "Алжир",
      alpha2Code: "DZ",
      alpha3Code: "DZA",
      callingCodes: [
        "213"
      ],
      capital: "Algiers",
      region: "Africa",
      latlng: [
        28,
        3
      ],
      demonym: "Algerian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dz.svg",
      currencies: [
        {
          code: "DZD",
          name: "Algerian dinar",
          symbol: "د.ج"
        }
      ]
    },
    {
      name: "American Samoa",
      nameRu: "Американское Самоа",
      alpha2Code: "AS",
      alpha3Code: "ASM",
      callingCodes: [
        "1"
      ],
      capital: "Pago Pago",
      region: "Oceania",
      latlng: [
        -14.33333333,
        -170
      ],
      demonym: "American Samoan",
      timezones: [
        "UTC-11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/as.svg",
      currencies: [
        {
          code: "USD",
          name: "United States Dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Andorra",
      nameRu: "Андорра",
      alpha2Code: "AD",
      alpha3Code: "AND",
      callingCodes: [
        "376"
      ],
      capital: "Andorra la Vella",
      region: "Europe",
      latlng: [
        42.5,
        1.5
      ],
      demonym: "Andorran",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ad.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Angola",
      nameRu: "Ангола",
      alpha2Code: "AO",
      alpha3Code: "AGO",
      callingCodes: [
        "244"
      ],
      capital: "Luanda",
      region: "Africa",
      latlng: [
        -12.5,
        18.5
      ],
      demonym: "Angolan",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ao.svg",
      currencies: [
        {
          code: "AOA",
          name: "Angolan kwanza",
          symbol: "Kz"
        }
      ]
    },
    {
      name: "Anguilla",
      nameRu: "Ангилья",
      alpha2Code: "AI",
      alpha3Code: "AIA",
      callingCodes: [
        "1"
      ],
      capital: "The Valley",
      region: "Americas",
      latlng: [
        18.25,
        -63.16666666
      ],
      demonym: "Anguillian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ai.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Antarctica",
      nameRu: "Антарктика",
      alpha2Code: "AQ",
      alpha3Code: "ATA",
      callingCodes: [
        "672"
      ],
      capital: null,
      region: "Polar",
      latlng: [
        -74.65,
        4.48
      ],
      demonym: "Antarctic",
      timezones: [
        "UTC-03:00",
        "UTC+03:00",
        "UTC+05:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/aq.svg",
      currencies: null
    },
    {
      name: "Antigua and Barbuda",
      nameRu: "Антигуа и Барбуда",
      alpha2Code: "AG",
      alpha3Code: "ATG",
      callingCodes: [
        "1"
      ],
      capital: "Saint John's",
      region: "Americas",
      latlng: [
        17.05,
        -61.8
      ],
      demonym: "Antiguan, Barbudan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ag.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Argentina",
      nameRu: "Аргентина",
      alpha2Code: "AR",
      alpha3Code: "ARG",
      callingCodes: [
        "54"
      ],
      capital: "Buenos Aires",
      region: "Americas",
      latlng: [
        -34,
        -64
      ],
      demonym: "Argentinean",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ar.svg",
      currencies: [
        {
          code: "ARS",
          name: "Argentine peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Armenia",
      nameRu: "Армения",
      alpha2Code: "AM",
      alpha3Code: "ARM",
      callingCodes: [
        "374"
      ],
      capital: "Yerevan",
      region: "Asia",
      latlng: [
        40,
        45
      ],
      demonym: "Armenian",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/am.svg",
      currencies: [
        {
          code: "AMD",
          name: "Armenian dram",
          symbol: "֏"
        }
      ]
    },
    {
      name: "Aruba",
      nameRu: "Аруба",
      alpha2Code: "AW",
      alpha3Code: "ABW",
      callingCodes: [
        "297"
      ],
      capital: "Oranjestad",
      region: "Americas",
      latlng: [
        12.5,
        -69.96666666
      ],
      demonym: "Aruban",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/aw.svg",
      currencies: [
        {
          code: "AWG",
          name: "Aruban florin",
          symbol: "ƒ"
        }
      ]
    },
    {
      name: "Australia",
      nameRu: "Австралия",
      alpha2Code: "AU",
      alpha3Code: "AUS",
      callingCodes: [
        "61"
      ],
      capital: "Canberra",
      region: "Oceania",
      latlng: [
        -27,
        133
      ],
      demonym: "Australian",
      timezones: [
        "UTC+05:00",
        "UTC+06:30",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:30",
        "UTC+10:00",
        "UTC+10:30",
        "UTC+11:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/au.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Austria",
      nameRu: "Австрия",
      alpha2Code: "AT",
      alpha3Code: "AUT",
      callingCodes: [
        "43"
      ],
      capital: "Vienna",
      region: "Europe",
      latlng: [
        47.33333333,
        13.33333333
      ],
      demonym: "Austrian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/at.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Azerbaijan",
      nameRu: "Азербайджан",
      alpha2Code: "AZ",
      alpha3Code: "AZE",
      callingCodes: [
        "994"
      ],
      capital: "Baku",
      region: "Asia",
      latlng: [
        40.5,
        47.5
      ],
      demonym: "Azerbaijani",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/az.svg",
      currencies: [
        {
          code: "AZN",
          name: "Azerbaijani manat",
          symbol: "₼"
        }
      ]
    },
    {
      name: "Bahamas",
      nameRu: "Багамские Острова",
      alpha2Code: "BS",
      alpha3Code: "BHS",
      callingCodes: [
        "1"
      ],
      capital: "Nassau",
      region: "Americas",
      latlng: [
        24.25,
        -76
      ],
      demonym: "Bahamian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bs.svg",
      currencies: [
        {
          code: "BSD",
          name: "Bahamian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bahrain",
      nameRu: "Бахрейн",
      alpha2Code: "BH",
      alpha3Code: "BHR",
      callingCodes: [
        "973"
      ],
      capital: "Manama",
      region: "Asia",
      latlng: [
        26,
        50.55
      ],
      demonym: "Bahraini",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bh.svg",
      currencies: [
        {
          code: "BHD",
          name: "Bahraini dinar",
          symbol: ".د.ب"
        }
      ]
    },
    {
      name: "Bangladesh",
      nameRu: "Бангладеш",
      alpha2Code: "BD",
      alpha3Code: "BGD",
      callingCodes: [
        "880"
      ],
      capital: "Dhaka",
      region: "Asia",
      latlng: [
        24,
        90
      ],
      demonym: "Bangladeshi",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bd.svg",
      currencies: [
        {
          code: "BDT",
          name: "Bangladeshi taka",
          symbol: "৳"
        }
      ]
    },
    {
      name: "Barbados",
      nameRu: "Барбадос",
      alpha2Code: "BB",
      alpha3Code: "BRB",
      callingCodes: [
        "1"
      ],
      capital: "Bridgetown",
      region: "Americas",
      latlng: [
        13.16666666,
        -59.53333333
      ],
      demonym: "Barbadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bb.svg",
      currencies: [
        {
          code: "BBD",
          name: "Barbadian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Belarus",
      nameRu: "Белоруссия (Беларусь)",
      alpha2Code: "BY",
      alpha3Code: "BLR",
      callingCodes: [
        "375"
      ],
      capital: "Minsk",
      region: "Europe",
      latlng: [
        53,
        28
      ],
      demonym: "Belarusian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/by.svg",
      currencies: [
        {
          code: "BYN",
          name: "New Belarusian ruble",
          symbol: "Br"
        },
        {
          code: "BYR",
          name: "Old Belarusian ruble",
          symbol: "Br"
        }
      ]
    },
    {
      name: "Belgium",
      nameRu: "Бельгия",
      alpha2Code: "BE",
      alpha3Code: "BEL",
      callingCodes: [
        "32"
      ],
      capital: "Brussels",
      region: "Europe",
      latlng: [
        50.83333333,
        4
      ],
      demonym: "Belgian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/be.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Belize",
      nameRu: "Белиз",
      alpha2Code: "BZ",
      alpha3Code: "BLZ",
      callingCodes: [
        "501"
      ],
      capital: "Belmopan",
      region: "Americas",
      latlng: [
        17.25,
        -88.75
      ],
      demonym: "Belizean",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bz.svg",
      currencies: [
        {
          code: "BZD",
          name: "Belize dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Benin",
      nameRu: "Бенин",
      alpha2Code: "BJ",
      alpha3Code: "BEN",
      callingCodes: [
        "229"
      ],
      capital: "Porto-Novo",
      region: "Africa",
      latlng: [
        9.5,
        2.25
      ],
      demonym: "Beninese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bj.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Bermuda",
      nameRu: "Бермудские Острова",
      alpha2Code: "BM",
      alpha3Code: "BMU",
      callingCodes: [
        "1"
      ],
      capital: "Hamilton",
      region: "Americas",
      latlng: [
        32.33333333,
        -64.75
      ],
      demonym: "Bermudian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bm.svg",
      currencies: [
        {
          code: "BMD",
          name: "Bermudian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bhutan",
      nameRu: "Бутан",
      alpha2Code: "BT",
      alpha3Code: "BTN",
      callingCodes: [
        "975"
      ],
      capital: "Thimphu",
      region: "Asia",
      latlng: [
        27.5,
        90.5
      ],
      demonym: "Bhutanese",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bt.svg",
      currencies: [
        {
          code: "BTN",
          name: "Bhutanese ngultrum",
          symbol: "Nu."
        },
        {
          code: "INR",
          name: "Indian rupee",
          symbol: "₹"
        }
      ]
    },
    {
      name: "Bolivia (Plurinational State of)",
      nameRu: "Боливия",
      alpha2Code: "BO",
      alpha3Code: "BOL",
      callingCodes: [
        "591"
      ],
      capital: "Sucre",
      region: "Americas",
      latlng: [
        -17,
        -65
      ],
      demonym: "Bolivian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bo.svg",
      currencies: [
        {
          code: "BOB",
          name: "Bolivian boliviano",
          symbol: "Bs."
        }
      ]
    },
    {
      name: "Bosnia and Herzegovina",
      nameRu: "Босния и Герцеговина",
      alpha2Code: "BA",
      alpha3Code: "BIH",
      callingCodes: [
        "387"
      ],
      capital: "Sarajevo",
      region: "Europe",
      latlng: [
        44,
        18
      ],
      demonym: "Bosnian, Herzegovinian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ba.svg",
      currencies: [
        {
          code: "BAM",
          name: "Bosnia and Herzegovina convertible mark",
          symbol: "KM"
        }
      ]
    },
    {
      name: "Botswana",
      nameRu: "Ботсвана",
      alpha2Code: "BW",
      alpha3Code: "BWA",
      callingCodes: [
        "267"
      ],
      capital: "Gaborone",
      region: "Africa",
      latlng: [
        -22,
        24
      ],
      demonym: "Motswana",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bw.svg",
      currencies: [
        {
          code: "BWP",
          name: "Botswana pula",
          symbol: "P"
        }
      ]
    },
    {
      name: "Bouvet Island",
      nameRu: "Буве, остров",
      alpha2Code: "BV",
      alpha3Code: "BVT",
      callingCodes: [
        "47"
      ],
      capital: null,
      region: "Antarctic Ocean",
      latlng: [
        -54.43333333,
        3.4
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bv.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Brazil",
      nameRu: "Бразилия",
      alpha2Code: "BR",
      alpha3Code: "BRA",
      callingCodes: [
        "55"
      ],
      capital: "Brasília",
      region: "Americas",
      latlng: [
        -10,
        -55
      ],
      demonym: "Brazilian",
      timezones: [
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/br.svg",
      currencies: [
        {
          code: "BRL",
          name: "Brazilian real",
          symbol: "R$"
        }
      ]
    },
    {
      name: "British Indian Ocean Territory",
      nameRu: "Британская территория в Индийском океане",
      alpha2Code: "IO",
      alpha3Code: "IOT",
      callingCodes: [
        "246"
      ],
      capital: "Diego Garcia",
      region: "Africa",
      latlng: [
        -6,
        71.5
      ],
      demonym: "Indian",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/io.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "United States Minor Outlying Islands",
      nameRu: "Мелкие отдаленные острова США",
      alpha2Code: "UM",
      alpha3Code: "UMI",
      callingCodes: [
        "246"
      ],
      capital: null,
      region: "Americas",
      latlng: null,
      demonym: "American",
      timezones: [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/um.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Virgin Islands (British)",
      nameRu: "Виргинские Острова (британские)",
      alpha2Code: "VG",
      alpha3Code: "VGB",
      callingCodes: [
        "1"
      ],
      capital: "Road Town",
      region: "Americas",
      latlng: [
        18.431383,
        -64.62305
      ],
      demonym: "Virgin Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vg.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Virgin Islands (U.S.)",
      nameRu: "Виргинские Острова (США)",
      alpha2Code: "VI",
      alpha3Code: "VIR",
      callingCodes: [
        "1 340"
      ],
      capital: "Charlotte Amalie",
      region: "Americas",
      latlng: [
        18.34,
        -64.93
      ],
      demonym: "Virgin Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vi.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Brunei Darussalam",
      nameRu: "Бруней",
      alpha2Code: "BN",
      alpha3Code: "BRN",
      callingCodes: [
        "673"
      ],
      capital: "Bandar Seri Begawan",
      region: "Asia",
      latlng: [
        4.5,
        114.66666666
      ],
      demonym: "Bruneian",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bn.svg",
      currencies: [
        {
          code: "BND",
          name: "Brunei dollar",
          symbol: "$"
        },
        {
          code: "SGD",
          name: "Singapore dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Bulgaria",
      nameRu: "Болгария",
      alpha2Code: "BG",
      alpha3Code: "BGR",
      callingCodes: [
        "359"
      ],
      capital: "Sofia",
      region: "Europe",
      latlng: [
        43,
        25
      ],
      demonym: "Bulgarian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bg.svg",
      currencies: [
        {
          code: "BGN",
          name: "Bulgarian lev",
          symbol: "лв"
        }
      ]
    },
    {
      name: "Burkina Faso",
      nameRu: "Буркина-Фасо",
      alpha2Code: "BF",
      alpha3Code: "BFA",
      callingCodes: [
        "226"
      ],
      capital: "Ouagadougou",
      region: "Africa",
      latlng: [
        13,
        -2
      ],
      demonym: "Burkinabe",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bf.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Burundi",
      nameRu: "Бурунди",
      alpha2Code: "BI",
      alpha3Code: "BDI",
      callingCodes: [
        "257"
      ],
      capital: "Gitega",
      region: "Africa",
      latlng: [
        -3.5,
        30
      ],
      demonym: "Burundian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/bi.svg",
      currencies: [
        {
          code: "BIF",
          name: "Burundian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Cambodia",
      nameRu: "Камбоджа",
      alpha2Code: "KH",
      alpha3Code: "KHM",
      callingCodes: [
        "855"
      ],
      capital: "Phnom Penh",
      region: "Asia",
      latlng: [
        13,
        105
      ],
      demonym: "Cambodian",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kh.svg",
      currencies: [
        {
          code: "KHR",
          name: "Cambodian riel",
          symbol: "៛"
        },
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cameroon",
      nameRu: "Камерун",
      alpha2Code: "CM",
      alpha3Code: "CMR",
      callingCodes: [
        "237"
      ],
      capital: "Yaoundé",
      region: "Africa",
      latlng: [
        6,
        12
      ],
      demonym: "Cameroonian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cm.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Canada",
      nameRu: "Канада",
      alpha2Code: "CA",
      alpha3Code: "CAN",
      callingCodes: [
        "1"
      ],
      capital: "Ottawa",
      region: "Americas",
      latlng: [
        60,
        -95
      ],
      demonym: "Canadian",
      timezones: [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ca.svg",
      currencies: [
        {
          code: "CAD",
          name: "Canadian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cabo Verde",
      nameRu: "Кабо-Верде",
      alpha2Code: "CV",
      alpha3Code: "CPV",
      callingCodes: [
        "238"
      ],
      capital: "Praia",
      region: "Africa",
      latlng: [
        16,
        -24
      ],
      demonym: "Cape Verdian",
      timezones: [
        "UTC-01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cv.svg",
      currencies: [
        {
          code: "CVE",
          name: "Cape Verdean escudo",
          symbol: "Esc"
        }
      ]
    },
    {
      name: "Cayman Islands",
      nameRu: "Кайман, Острова",
      alpha2Code: "KY",
      alpha3Code: "CYM",
      callingCodes: [
        "1"
      ],
      capital: "George Town",
      region: "Americas",
      latlng: [
        19.5,
        -80.5
      ],
      demonym: "Caymanian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ky.svg",
      currencies: [
        {
          code: "KYD",
          name: "Cayman Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Central African Republic",
      nameRu: "Центральноафриканская республика",
      alpha2Code: "CF",
      alpha3Code: "CAF",
      callingCodes: [
        "236"
      ],
      capital: "Bangui",
      region: "Africa",
      latlng: [
        7,
        21
      ],
      demonym: "Central African",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cf.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Chad",
      nameRu: "Чад",
      alpha2Code: "TD",
      alpha3Code: "TCD",
      callingCodes: [
        "235"
      ],
      capital: "N'Djamena",
      region: "Africa",
      latlng: [
        15,
        19
      ],
      demonym: "Chadian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/td.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Chile",
      nameRu: "Чили",
      alpha2Code: "CL",
      alpha3Code: "CHL",
      callingCodes: [
        "56"
      ],
      capital: "Santiago",
      region: "Americas",
      latlng: [
        -30,
        -71
      ],
      demonym: "Chilean",
      timezones: [
        "UTC-06:00",
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cl.svg",
      currencies: [
        {
          code: "CLP",
          name: "Chilean peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "China",
      nameRu: "Китай",
      alpha2Code: "CN",
      alpha3Code: "CHN",
      callingCodes: [
        "86"
      ],
      capital: "Beijing",
      region: "Asia",
      latlng: [
        35,
        105
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cn.svg",
      currencies: [
        {
          code: "CNY",
          name: "Chinese yuan",
          symbol: "¥"
        }
      ]
    },
    {
      name: "Christmas Island",
      nameRu: "Остров Рождества",
      alpha2Code: "CX",
      alpha3Code: "CXR",
      callingCodes: [
        "61"
      ],
      capital: "Flying Fish Cove",
      region: "Oceania",
      latlng: [
        -10.5,
        105.66666666
      ],
      demonym: "Christmas Island",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cx.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Cocos (Keeling) Islands",
      nameRu: "Кокосовые (Килинг) Острова",
      alpha2Code: "CC",
      alpha3Code: "CCK",
      callingCodes: [
        "61"
      ],
      capital: "West Island",
      region: "Oceania",
      latlng: [
        -12.5,
        96.83333333
      ],
      demonym: "Cocos Islander",
      timezones: [
        "UTC+06:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cc.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Colombia",
      nameRu: "Колумбия",
      alpha2Code: "CO",
      alpha3Code: "COL",
      callingCodes: [
        "57"
      ],
      capital: "Bogotá",
      region: "Americas",
      latlng: [
        4,
        -72
      ],
      demonym: "Colombian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/co.svg",
      currencies: [
        {
          code: "COP",
          name: "Colombian peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Comoros",
      nameRu: "Коморские Острова",
      alpha2Code: "KM",
      alpha3Code: "COM",
      callingCodes: [
        "269"
      ],
      capital: "Moroni",
      region: "Africa",
      latlng: [
        -12.16666666,
        44.25
      ],
      demonym: "Comoran",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/km.svg",
      currencies: [
        {
          code: "KMF",
          name: "Comorian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Congo",
      nameRu: "Конго",
      alpha2Code: "CG",
      alpha3Code: "COG",
      callingCodes: [
        "242"
      ],
      capital: "Brazzaville",
      region: "Africa",
      latlng: [
        -1,
        15
      ],
      demonym: "Congolese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cg.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Congo (Democratic Republic of the)",
      nameRu: "Демократическая Республика Конго",
      alpha2Code: "CD",
      alpha3Code: "COD",
      callingCodes: [
        "243"
      ],
      capital: "Kinshasa",
      region: "Africa",
      latlng: [
        0,
        25
      ],
      demonym: "Congolese",
      timezones: [
        "UTC+01:00",
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cd.svg",
      currencies: [
        {
          code: "CDF",
          name: "Congolese franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Cook Islands",
      nameRu: "Острова Кука",
      alpha2Code: "CK",
      alpha3Code: "COK",
      callingCodes: [
        "682"
      ],
      capital: "Avarua",
      region: "Oceania",
      latlng: [
        -21.23333333,
        -159.76666666
      ],
      demonym: "Cook Islander",
      timezones: [
        "UTC-10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ck.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "CKD",
          name: "Cook Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Costa Rica",
      nameRu: "Коста-Рика",
      alpha2Code: "CR",
      alpha3Code: "CRI",
      callingCodes: [
        "506"
      ],
      capital: "San José",
      region: "Americas",
      latlng: [
        10,
        -84
      ],
      demonym: "Costa Rican",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cr.svg",
      currencies: [
        {
          code: "CRC",
          name: "Costa Rican colón",
          symbol: "₡"
        }
      ]
    },
    {
      name: "Croatia",
      nameRu: "Хорватия",
      alpha2Code: "HR",
      alpha3Code: "HRV",
      callingCodes: [
        "385"
      ],
      capital: "Zagreb",
      region: "Europe",
      latlng: [
        45.16666666,
        15.5
      ],
      demonym: "Croatian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Cuba",
      nameRu: "Куба",
      alpha2Code: "CU",
      alpha3Code: "CUB",
      callingCodes: [
        "53"
      ],
      capital: "Havana",
      region: "Americas",
      latlng: [
        21.5,
        -80
      ],
      demonym: "Cuban",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cu.svg",
      currencies: [
        {
          code: "CUC",
          name: "Cuban convertible peso",
          symbol: "$"
        },
        {
          code: "CUP",
          name: "Cuban peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Curaçao",
      nameRu: "Кюрасао",
      alpha2Code: "CW",
      alpha3Code: "CUW",
      callingCodes: [
        "599"
      ],
      capital: "Willemstad",
      region: "Americas",
      latlng: [
        12.116667,
        -68.933333
      ],
      demonym: "Dutch",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cw.svg",
      currencies: [
        {
          code: "ANG",
          name: "Netherlands Antillean guilder",
          symbol: "ƒ"
        }
      ]
    },
    {
      name: "Cyprus",
      nameRu: "Кипр",
      alpha2Code: "CY",
      alpha3Code: "CYP",
      callingCodes: [
        "357"
      ],
      capital: "Nicosia",
      region: "Europe",
      latlng: [
        35,
        33
      ],
      demonym: "Cypriot",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cy.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Czech Republic",
      nameRu: "Чешская Республика",
      alpha2Code: "CZ",
      alpha3Code: "CZE",
      callingCodes: [
        "420"
      ],
      capital: "Prague",
      region: "Europe",
      latlng: [
        49.75,
        15.5
      ],
      demonym: "Czech",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/cz.svg",
      currencies: [
        {
          code: "CZK",
          name: "Czech koruna",
          symbol: "Kč"
        }
      ]
    },
    {
      name: "Denmark",
      nameRu: "Дания",
      alpha2Code: "DK",
      alpha3Code: "DNK",
      callingCodes: [
        "45"
      ],
      capital: "Copenhagen",
      region: "Europe",
      latlng: [
        56,
        10
      ],
      demonym: "Danish",
      timezones: [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dk.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Djibouti",
      nameRu: "Джибути",
      alpha2Code: "DJ",
      alpha3Code: "DJI",
      callingCodes: [
        "253"
      ],
      capital: "Djibouti",
      region: "Africa",
      latlng: [
        11.5,
        43
      ],
      demonym: "Djibouti",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dj.svg",
      currencies: [
        {
          code: "DJF",
          name: "Djiboutian franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Dominica",
      nameRu: "Доминика",
      alpha2Code: "DM",
      alpha3Code: "DMA",
      callingCodes: [
        "1"
      ],
      capital: "Roseau",
      region: "Americas",
      latlng: [
        15.41666666,
        -61.33333333
      ],
      demonym: "Dominican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/dm.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Dominican Republic",
      nameRu: "Доминиканская Республика",
      alpha2Code: "DO",
      alpha3Code: "DOM",
      callingCodes: [
        "1"
      ],
      capital: "Santo Domingo",
      region: "Americas",
      latlng: [
        19,
        -70.66666666
      ],
      demonym: "Dominican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/do.svg",
      currencies: [
        {
          code: "DOP",
          name: "Dominican peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Ecuador",
      nameRu: "Эквадор",
      alpha2Code: "EC",
      alpha3Code: "ECU",
      callingCodes: [
        "593"
      ],
      capital: "Quito",
      region: "Americas",
      latlng: [
        -2,
        -77.5
      ],
      demonym: "Ecuadorean",
      timezones: [
        "UTC-06:00",
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ec.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Egypt",
      nameRu: "Египет",
      alpha2Code: "EG",
      alpha3Code: "EGY",
      callingCodes: [
        "20"
      ],
      capital: "Cairo",
      region: "Africa",
      latlng: [
        27,
        30
      ],
      demonym: "Egyptian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/eg.svg",
      currencies: [
        {
          code: "EGP",
          name: "Egyptian pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "El Salvador",
      nameRu: "Сальвадор",
      alpha2Code: "SV",
      alpha3Code: "SLV",
      callingCodes: [
        "503"
      ],
      capital: "San Salvador",
      region: "Americas",
      latlng: [
        13.83333333,
        -88.91666666
      ],
      demonym: "Salvadoran",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sv.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Equatorial Guinea",
      nameRu: "Экваториальная Гвинея",
      alpha2Code: "GQ",
      alpha3Code: "GNQ",
      callingCodes: [
        "240"
      ],
      capital: "Malabo",
      region: "Africa",
      latlng: [
        2,
        10
      ],
      demonym: "Equatorial Guinean",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gq.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Eritrea",
      nameRu: "Эритрея",
      alpha2Code: "ER",
      alpha3Code: "ERI",
      callingCodes: [
        "291"
      ],
      capital: "Asmara",
      region: "Africa",
      latlng: [
        15,
        39
      ],
      demonym: "Eritrean",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/er.svg",
      currencies: [
        {
          code: "ERN",
          name: "Eritrean nakfa",
          symbol: "Nfk"
        }
      ]
    },
    {
      name: "Estonia",
      nameRu: "Эстония",
      alpha2Code: "EE",
      alpha3Code: "EST",
      callingCodes: [
        "372"
      ],
      capital: "Tallinn",
      region: "Europe",
      latlng: [
        59,
        26
      ],
      demonym: "Estonian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ee.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Ethiopia",
      nameRu: "Эфиопия",
      alpha2Code: "ET",
      alpha3Code: "ETH",
      callingCodes: [
        "251"
      ],
      capital: "Addis Ababa",
      region: "Africa",
      latlng: [
        8,
        38
      ],
      demonym: "Ethiopian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/et.svg",
      currencies: [
        {
          code: "ETB",
          name: "Ethiopian birr",
          symbol: "Br"
        }
      ]
    },
    {
      name: "Falkland Islands (Malvinas)",
      nameRu: "Фолклендские (Мальвинские) Острова",
      alpha2Code: "FK",
      alpha3Code: "FLK",
      callingCodes: [
        "500"
      ],
      capital: "Stanley",
      region: "Americas",
      latlng: [
        -51.75,
        -59
      ],
      demonym: "Falkland Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fk.svg",
      currencies: [
        {
          code: "FKP",
          name: "Falkland Islands pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Faroe Islands",
      nameRu: "Фарерские Острова",
      alpha2Code: "FO",
      alpha3Code: "FRO",
      callingCodes: [
        "298"
      ],
      capital: "Tórshavn",
      region: "Europe",
      latlng: [
        62,
        -7
      ],
      demonym: "Faroese",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fo.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        },
        {
          code: "FOK",
          name: "Faroese króna",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Fiji",
      nameRu: "Фиджи",
      alpha2Code: "FJ",
      alpha3Code: "FJI",
      callingCodes: [
        "679"
      ],
      capital: "Suva",
      region: "Oceania",
      latlng: [
        -18,
        175
      ],
      demonym: "Fijian",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fj.svg",
      currencies: [
        {
          code: "FJD",
          name: "Fijian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Finland",
      nameRu: "Финляндия",
      alpha2Code: "FI",
      alpha3Code: "FIN",
      callingCodes: [
        "358"
      ],
      capital: "Helsinki",
      region: "Europe",
      latlng: [
        64,
        26
      ],
      demonym: "Finnish",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fi.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "France",
      nameRu: "Франция",
      alpha2Code: "FR",
      alpha3Code: "FRA",
      callingCodes: [
        "33"
      ],
      capital: "Paris",
      region: "Europe",
      latlng: [
        46,
        2
      ],
      demonym: "French",
      timezones: [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+03:00",
        "UTC+04:00",
        "UTC+05:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "French Guiana",
      nameRu: "Французская Гвиана",
      alpha2Code: "GF",
      alpha3Code: "GUF",
      callingCodes: [
        "594"
      ],
      capital: "Cayenne",
      region: "Americas",
      latlng: [
        4,
        -53
      ],
      demonym: "French Guianan",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gf.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "French Polynesia",
      nameRu: "Французская Полинезия",
      alpha2Code: "PF",
      alpha3Code: "PYF",
      callingCodes: [
        "689"
      ],
      capital: "Papeetē",
      region: "Oceania",
      latlng: [
        -15,
        -140
      ],
      demonym: "French Polynesian",
      timezones: [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pf.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "French Southern Territories",
      nameRu: "Французские Южные Территории",
      alpha2Code: "TF",
      alpha3Code: "ATF",
      callingCodes: [
        "262"
      ],
      capital: "Port-aux-Français",
      region: "Africa",
      latlng: [
        -49.25,
        69.167
      ],
      demonym: "French",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tf.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Gabon",
      nameRu: "Габон",
      alpha2Code: "GA",
      alpha3Code: "GAB",
      callingCodes: [
        "241"
      ],
      capital: "Libreville",
      region: "Africa",
      latlng: [
        -1,
        11.75
      ],
      demonym: "Gabonese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ga.svg",
      currencies: [
        {
          code: "XAF",
          name: "Central African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Gambia",
      nameRu: "Гамбия",
      alpha2Code: "GM",
      alpha3Code: "GMB",
      callingCodes: [
        "220"
      ],
      capital: "Banjul",
      region: "Africa",
      latlng: [
        13.46666666,
        -16.56666666
      ],
      demonym: "Gambian",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gm.svg",
      currencies: [
        {
          code: "GMD",
          name: "Gambian dalasi",
          symbol: "D"
        }
      ]
    },
    {
      name: "Georgia",
      nameRu: "Грузия",
      alpha2Code: "GE",
      alpha3Code: "GEO",
      callingCodes: [
        "995"
      ],
      capital: "Tbilisi",
      region: "Asia",
      latlng: [
        42,
        43.5
      ],
      demonym: "Georgian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ge.svg",
      currencies: [
        {
          code: "GEL",
          name: "Georgian Lari",
          symbol: "ლ"
        }
      ]
    },
    {
      name: "Germany",
      nameRu: "Германия",
      alpha2Code: "DE",
      alpha3Code: "DEU",
      callingCodes: [
        "49"
      ],
      capital: "Berlin",
      region: "Europe",
      latlng: [
        51,
        9
      ],
      demonym: "German",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/de.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Ghana",
      nameRu: "Гана",
      alpha2Code: "GH",
      alpha3Code: "GHA",
      callingCodes: [
        "233"
      ],
      capital: "Accra",
      region: "Africa",
      latlng: [
        8,
        -2
      ],
      demonym: "Ghanaian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gh.svg",
      currencies: [
        {
          code: "GHS",
          name: "Ghanaian cedi",
          symbol: "₵"
        }
      ]
    },
    {
      name: "Gibraltar",
      nameRu: "Гибралтар",
      alpha2Code: "GI",
      alpha3Code: "GIB",
      callingCodes: [
        "350"
      ],
      capital: "Gibraltar",
      region: "Europe",
      latlng: [
        36.13333333,
        -5.35
      ],
      demonym: "Gibraltar",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gi.svg",
      currencies: [
        {
          code: "GIP",
          name: "Gibraltar pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Greece",
      NameRu: "Греция",
      alpha2Code: "GR",
      alpha3Code: "GRC",
      callingCodes: [
        "30"
      ],
      capital: "Athens",
      region: "Europe",
      latlng: [
        39,
        22
      ],
      demonym: "Greek",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gr.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Greenland",
      nameRu: "Гренландия",
      alpha2Code: "GL",
      alpha3Code: "GRL",
      callingCodes: [
        "299"
      ],
      capital: "Nuuk",
      region: "Americas",
      latlng: [
        72,
        -40
      ],
      demonym: "Greenlandic",
      timezones: [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gl.svg",
      currencies: [
        {
          code: "DKK",
          name: "Danish krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Grenada",
      nameRu: "Гренада",
      alpha2Code: "GD",
      alpha3Code: "GRD",
      callingCodes: [
        "1"
      ],
      capital: "St. George's",
      region: "Americas",
      latlng: [
        12.11666666,
        -61.66666666
      ],
      demonym: "Grenadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gd.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Guadeloupe",
      nameRu: "Гваделупа",
      alpha2Code: "GP",
      alpha3Code: "GLP",
      callingCodes: [
        "590"
      ],
      capital: "Basse-Terre",
      region: "Americas",
      latlng: [
        16.25,
        -61.583333
      ],
      demonym: "Guadeloupian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gp.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Guam",
      nameRu: "Гуам",
      alpha2Code: "GU",
      alpha3Code: "GUM",
      callingCodes: [
        "1"
      ],
      capital: "Hagåtña",
      region: "Oceania",
      latlng: [
        13.46666666,
        144.78333333
      ],
      demonym: "Guamanian",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gu.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Guatemala",
      nameRu: "Гватемала",
      alpha2Code: "GT",
      alpha3Code: "GTM",
      callingCodes: [
        "502"
      ],
      capital: "Guatemala City",
      region: "Americas",
      latlng: [
        15.5,
        -90.25
      ],
      demonym: "Guatemalan",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gt.svg",
      currencies: [
        {
          code: "GTQ",
          name: "Guatemalan quetzal",
          symbol: "Q"
        }
      ]
    },
    {
      name: "Guernsey",
      nameRu: "Гернси",
      alpha2Code: "GG",
      alpha3Code: "GGY",
      callingCodes: [
        "44"
      ],
      capital: "St. Peter Port",
      region: "Europe",
      latlng: [
        49.46666666,
        -2.58333333
      ],
      demonym: "Channel Islander",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gg.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "GGP",
          name: "Guernsey pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Guinea",
      nameRu: "Гвинея",
      alpha2Code: "GN",
      alpha3Code: "GIN",
      callingCodes: [
        "224"
      ],
      capital: "Conakry",
      region: "Africa",
      latlng: [
        11,
        -10
      ],
      demonym: "Guinean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gn.svg",
      currencies: [
        {
          code: "GNF",
          name: "Guinean franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Guinea-Bissau",
      nameRu: "Гвинея-Бисау",
      alpha2Code: "GW",
      alpha3Code: "GNB",
      callingCodes: [
        "245"
      ],
      capital: "Bissau",
      region: "Africa",
      latlng: [
        12,
        -15
      ],
      demonym: "Guinea-Bissauan",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gw.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Guyana",
      nameRu: "Гайана",
      alpha2Code: "GY",
      alpha3Code: "GUY",
      callingCodes: [
        "592"
      ],
      capital: "Georgetown",
      region: "Americas",
      latlng: [
        5,
        -59
      ],
      demonym: "Guyanese",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gy.svg",
      currencies: [
        {
          code: "GYD",
          name: "Guyanese dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Haiti",
      nameRu: "Гаити",
      alpha2Code: "HT",
      alpha3Code: "HTI",
      callingCodes: [
        "509"
      ],
      capital: "Port-au-Prince",
      region: "Americas",
      latlng: [
        19,
        -72.41666666
      ],
      demonym: "Haitian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ht.svg",
      currencies: [
        {
          code: "HTG",
          name: "Haitian gourde",
          symbol: "G"
        }
      ]
    },
    {
      name: "Heard Island and McDonald Islands",
      nameRu: "Херд и Макдональн, острова",
      alpha2Code: "HM",
      alpha3Code: "HMD",
      callingCodes: [
        "672"
      ],
      capital: null,
      region: "Antarctic",
      latlng: [
        -53.1,
        72.51666666
      ],
      demonym: "Heard and McDonald Islander",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hm.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Vatican City",
      nameRu: "Ватикан",
      alpha2Code: "VA",
      alpha3Code: "VAT",
      callingCodes: [
        "379"
      ],
      capital: "Vatican City",
      region: "Europe",
      latlng: [
        41.9,
        12.45
      ],
      demonym: "Vatican",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/va.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Honduras",
      nameRu: "Гондурас",
      alpha2Code: "HN",
      alpha3Code: "HND",
      callingCodes: [
        "504"
      ],
      capital: "Tegucigalpa",
      region: "Americas",
      latlng: [
        15,
        -86.5
      ],
      demonym: "Honduran",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hn.svg",
      currencies: [
        {
          code: "HNL",
          name: "Honduran lempira",
          symbol: "L"
        }
      ]
    },
    {
      name: "Hungary",
      nameRu: "Венгрия",
      alpha2Code: "HU",
      alpha3Code: "HUN",
      callingCodes: [
        "36"
      ],
      capital: "Budapest",
      region: "Europe",
      latlng: [
        47,
        20
      ],
      demonym: "Hungarian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hu.svg",
      currencies: [
        {
          code: "HUF",
          name: "Hungarian forint",
          symbol: "Ft"
        }
      ]
    },
    {
      name: "Hong Kong",
      nameRu: "Гонконг (Сянган)",
      alpha2Code: "HK",
      alpha3Code: "HKG",
      callingCodes: [
        "852"
      ],
      capital: "City of Victoria",
      region: "Asia",
      latlng: [
        22.25,
        114.16666666
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/hk.svg",
      currencies: [
        {
          code: "HKD",
          name: "Hong Kong dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Iceland",
      nameRu: "Исландия",
      alpha2Code: "IS",
      alpha3Code: "ISL",
      callingCodes: [
        "354"
      ],
      capital: "Reykjavík",
      region: "Europe",
      latlng: [
        65,
        -18
      ],
      demonym: "Icelander",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/is.svg",
      currencies: [
        {
          code: "ISK",
          name: "Icelandic króna",
          symbol: "kr"
        }
      ]
    },
    {
      name: "India",
      nameRu: "Индия",
      alpha2Code: "IN",
      alpha3Code: "IND",
      callingCodes: [
        "91"
      ],
      capital: "New Delhi",
      region: "Asia",
      latlng: [
        20,
        77
      ],
      demonym: "Indian",
      timezones: [
        "UTC+05:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/in.svg",
      currencies: [
        {
          code: "INR",
          name: "Indian rupee",
          symbol: "₹"
        }
      ]
    },
    {
      name: "Indonesia",
      nameRu: "Индонезия",
      alpha2Code: "ID",
      alpha3Code: "IDN",
      callingCodes: [
        "62"
      ],
      capital: "Jakarta",
      region: "Asia",
      latlng: [
        -5,
        120
      ],
      demonym: "Indonesian",
      timezones: [
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/id.svg",
      currencies: [
        {
          code: "IDR",
          name: "Indonesian rupiah",
          symbol: "Rp"
        }
      ]
    },
    {
      name: "Ivory Coast",
      nameRu: "Кот-д'Ивуар",
      alpha2Code: "CI",
      alpha3Code: "CIV",
      callingCodes: [
        "225"
      ],
      capital: "Yamoussoukro",
      region: "Africa",
      latlng: [
        8,
        -5
      ],
      demonym: "Ivorian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ci.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Iran (Islamic Republic of)",
      nameRu: "Иран",
      alpha2Code: "IR",
      alpha3Code: "IRN",
      callingCodes: [
        "98"
      ],
      capital: "Tehran",
      region: "Asia",
      latlng: [
        32,
        53
      ],
      demonym: "Iranian",
      timezones: [
        "UTC+03:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ir.svg",
      currencies: [
        {
          code: "IRR",
          name: "Iranian rial",
          symbol: "﷼"
        }
      ]
    },
    {
      name: "Iraq",
      nameRu: "Ирак",
      alpha2Code: "IQ",
      alpha3Code: "IRQ",
      callingCodes: [
        "964"
      ],
      capital: "Baghdad",
      region: "Asia",
      latlng: [
        33,
        44
      ],
      demonym: "Iraqi",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/iq.svg",
      currencies: [
        {
          code: "IQD",
          name: "Iraqi dinar",
          symbol: "ع.د"
        }
      ]
    },
    {
      name: "Ireland",
      nameRu: "Ирландия",
      alpha2Code: "IE",
      alpha3Code: "IRL",
      callingCodes: [
        "353"
      ],
      capital: "Dublin",
      region: "Europe",
      latlng: [
        53,
        -8
      ],
      demonym: "Irish",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ie.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Isle of Man",
      nameRu: "Остров Мэн",
      alpha2Code: "IM",
      alpha3Code: "IMN",
      callingCodes: [
        "44"
      ],
      capital: "Douglas",
      region: "Europe",
      latlng: [
        54.25,
        -4.5
      ],
      demonym: "Manx",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/im.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "IMP[G]",
          name: "Manx pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Israel",
      nameRu: "Израиль",
      alpha2Code: "IL",
      alpha3Code: "ISR",
      callingCodes: [
        "972"
      ],
      capital: "Jerusalem",
      region: "Asia",
      latlng: [
        31.5,
        34.75
      ],
      demonym: "Israeli",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/il.svg",
      currencies: [
        {
          code: "ILS",
          name: "Israeli new shekel",
          symbol: "₪"
        }
      ]
    },
    {
      name: "Italy",
      nameRu: "Италия",
      alpha2Code: "IT",
      alpha3Code: "ITA",
      callingCodes: [
        "39"
      ],
      capital: "Rome",
      region: "Europe",
      latlng: [
        42.83333333,
        12.83333333
      ],
      demonym: "Italian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/it.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Jamaica",
      nameRu: "Ямайка",
      alpha2Code: "JM",
      alpha3Code: "JAM",
      callingCodes: [
        "1"
      ],
      capital: "Kingston",
      region: "Americas",
      latlng: [
        18.25,
        -77.5
      ],
      demonym: "Jamaican",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jm.svg",
      currencies: [
        {
          code: "JMD",
          name: "Jamaican dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Japan",
      nameRu: "Япония",
      alpha2Code: "JP",
      alpha3Code: "JPN",
      callingCodes: [
        "81"
      ],
      capital: "Tokyo",
      region: "Asia",
      latlng: [
        36,
        138
      ],
      demonym: "Japanese",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jp.svg",
      currencies: [
        {
          code: "JPY",
          name: "Japanese yen",
          symbol: "¥"
        }
      ]
    },
    {
      name: "Jersey",
      nameRu: "Джерси",
      alpha2Code: "JE",
      alpha3Code: "JEY",
      callingCodes: [
        "44"
      ],
      capital: "Saint Helier",
      region: "Europe",
      latlng: [
        49.25,
        -2.16666666
      ],
      demonym: "Channel Islander",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/je.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        },
        {
          code: "JEP[G]",
          name: "Jersey pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Jordan",
      nameRu: "Иордания",
      alpha2Code: "JO",
      alpha3Code: "JOR",
      callingCodes: [
        "962"
      ],
      capital: "Amman",
      region: "Asia",
      latlng: [
        31,
        36
      ],
      demonym: "Jordanian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/jo.svg",
      currencies: [
        {
          code: "JOD",
          name: "Jordanian dinar",
          symbol: "د.ا"
        }
      ]
    },
    {
      name: "Kazakhstan",
      nameRu: "Казахстан",
      alpha2Code: "KZ",
      alpha3Code: "KAZ",
      callingCodes: [
        "76",
        "77"
      ],
      capital: "Nur-Sultan",
      region: "Asia",
      latlng: [
        48,
        68
      ],
      demonym: "Kazakhstani",
      timezones: [
        "UTC+05:00",
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kz.svg",
      currencies: [
        {
          code: "KZT",
          name: "Kazakhstani tenge",
          symbol: "₸"
        }
      ]
    },
    {
      name: "Kenya",
      nameRu: "Кения",
      alpha2Code: "KE",
      alpha3Code: "KEN",
      callingCodes: [
        "254"
      ],
      capital: "Nairobi",
      region: "Africa",
      latlng: [
        1,
        38
      ],
      demonym: "Kenyan",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ke.svg",
      currencies: [
        {
          code: "KES",
          name: "Kenyan shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Kiribati",
      nameRu: "Кирибати",
      alpha2Code: "KI",
      alpha3Code: "KIR",
      callingCodes: [
        "686"
      ],
      capital: "South Tarawa",
      region: "Oceania",
      latlng: [
        1.41666666,
        173
      ],
      demonym: "I-Kiribati",
      timezones: [
        "UTC+12:00",
        "UTC+13:00",
        "UTC+14:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ki.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        },
        {
          code: "KID",
          name: "Kiribati dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Kuwait",
      nameRu: "Кувейт",
      alpha2Code: "KW",
      alpha3Code: "KWT",
      callingCodes: [
        "965"
      ],
      capital: "Kuwait City",
      region: "Asia",
      latlng: [
        29.5,
        45.75
      ],
      demonym: "Kuwaiti",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kw.svg",
      currencies: [
        {
          code: "KWD",
          name: "Kuwaiti dinar",
          symbol: "د.ك"
        }
      ]
    },
    {
      name: "Kyrgyzstan",
      nameRu: "Киргизия (Кыргызстан)",
      alpha2Code: "KG",
      alpha3Code: "KGZ",
      callingCodes: [
        "996"
      ],
      capital: "Bishkek",
      region: "Asia",
      latlng: [
        41,
        75
      ],
      demonym: "Kirghiz",
      timezones: [
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kg.svg",
      currencies: [
        {
          code: "KGS",
          name: "Kyrgyzstani som",
          symbol: "с"
        }
      ]
    },
    {
      name: "Lao People's Democratic Republic",
      nameRu: "Лаос",
      alpha2Code: "LA",
      alpha3Code: "LAO",
      callingCodes: [
        "856"
      ],
      capital: "Vientiane",
      region: "Asia",
      latlng: [
        18,
        105
      ],
      demonym: "Laotian",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/la.svg",
      currencies: [
        {
          code: "LAK",
          name: "Lao kip",
          symbol: "₭"
        }
      ]
    },
    {
      name: "Latvia",
      nameRu: "Латвия",
      alpha2Code: "LV",
      alpha3Code: "LVA",
      callingCodes: [
        "371"
      ],
      capital: "Riga",
      region: "Europe",
      latlng: [
        57,
        25
      ],
      demonym: "Latvian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lv.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Lebanon",
      nameRu: "Ливан",
      alpha2Code: "LB",
      alpha3Code: "LBN",
      callingCodes: [
        "961"
      ],
      capital: "Beirut",
      region: "Asia",
      latlng: [
        33.83333333,
        35.83333333
      ],
      demonym: "Lebanese",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lb.svg",
      currencies: [
        {
          code: "LBP",
          name: "Lebanese pound",
          symbol: "ل.ل"
        }
      ]
    },
    {
      name: "Lesotho",
      nameRu: "Лесото",
      alpha2Code: "LS",
      alpha3Code: "LSO",
      callingCodes: [
        "266"
      ],
      capital: "Maseru",
      region: "Africa",
      latlng: [
        -29.5,
        28.5
      ],
      demonym: "Mosotho",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ls.svg",
      currencies: [
        {
          code: "LSL",
          name: "Lesotho loti",
          symbol: "L"
        },
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "Liberia",
      nameRu: "Либерия",
      alpha2Code: "LR",
      alpha3Code: "LBR",
      callingCodes: [
        "231"
      ],
      capital: "Monrovia",
      region: "Africa",
      latlng: [
        6.5,
        -9.5
      ],
      demonym: "Liberian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lr.svg",
      currencies: [
        {
          code: "LRD",
          name: "Liberian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Libya",
      nameRu: "Ливия",
      alpha2Code: "LY",
      alpha3Code: "LBY",
      callingCodes: [
        "218"
      ],
      capital: "Tripoli",
      region: "Africa",
      latlng: [
        25,
        17
      ],
      demonym: "Libyan",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ly.svg",
      currencies: [
        {
          code: "LYD",
          name: "Libyan dinar",
          symbol: "ل.د"
        }
      ]
    },
    {
      name: "Liechtenstein",
      nameRu: "Лихтенштейн",
      alpha2Code: "LI",
      alpha3Code: "LIE",
      callingCodes: [
        "423"
      ],
      capital: "Vaduz",
      region: "Europe",
      latlng: [
        47.26666666,
        9.53333333
      ],
      demonym: "Liechtensteiner",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/li.svg",
      currencies: [
        {
          code: "CHF",
          name: "Swiss franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Lithuania",
      nameRu: "Литва",
      alpha2Code: "LT",
      alpha3Code: "LTU",
      callingCodes: [
        "370"
      ],
      capital: "Vilnius",
      region: "Europe",
      latlng: [
        56,
        24
      ],
      demonym: "Lithuanian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Luxembourg",
      nameRu: "Люксембург",
      alpha2Code: "LU",
      alpha3Code: "LUX",
      callingCodes: [
        "352"
      ],
      capital: "Luxembourg",
      region: "Europe",
      latlng: [
        49.75,
        6.16666666
      ],
      demonym: "Luxembourger",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lu.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Macao",
      nameRu: "Аомынь (Макао)",
      alpha2Code: "MO",
      alpha3Code: "MAC",
      callingCodes: [
        "853"
      ],
      capital: null,
      region: "Asia",
      latlng: [
        22.16666666,
        113.55
      ],
      demonym: "Chinese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mo.svg",
      currencies: [
        {
          code: "MOP",
          name: "Macanese pataca",
          symbol: "P"
        }
      ]
    },
    {
      name: "North Macedonia",
      nameRu: "Македония",
      alpha2Code: "MK",
      alpha3Code: "MKD",
      callingCodes: [
        "389"
      ],
      capital: "Skopje",
      region: "Europe",
      latlng: [
        41.83333333,
        22
      ],
      demonym: "Macedonian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mk.svg",
      currencies: [
        {
          code: "MKD",
          name: "Macedonian denar",
          symbol: "ден"
        }
      ]
    },
    {
      name: "Madagascar",
      nameRu: "Мадагаскар",
      alpha2Code: "MG",
      alpha3Code: "MDG",
      callingCodes: [
        "261"
      ],
      capital: "Antananarivo",
      region: "Africa",
      latlng: [
        -20,
        47
      ],
      demonym: "Malagasy",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mg.svg",
      currencies: [
        {
          code: "MGA",
          name: "Malagasy ariary",
          symbol: "Ar"
        }
      ]
    },
    {
      name: "Malawi",
      nameRu: "Малави",
      alpha2Code: "MW",
      alpha3Code: "MWI",
      callingCodes: [
        "265"
      ],
      capital: "Lilongwe",
      region: "Africa",
      latlng: [
        -13.5,
        34
      ],
      demonym: "Malawian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mw.svg",
      currencies: [
        {
          code: "MWK",
          name: "Malawian kwacha",
          symbol: "MK"
        }
      ]
    },
    {
      name: "Malaysia",
      nameRu: "Малайзия",
      alpha2Code: "MY",
      alpha3Code: "MYS",
      callingCodes: [
        "60"
      ],
      capital: "Kuala Lumpur",
      region: "Asia",
      latlng: [
        2.5,
        112.5
      ],
      demonym: "Malaysian",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/my.svg",
      currencies: [
        {
          code: "MYR",
          name: "Malaysian ringgit",
          symbol: "RM"
        }
      ]
    },
    {
      name: "Maldives",
      nameRu: "Мальдивы",
      alpha2Code: "MV",
      alpha3Code: "MDV",
      callingCodes: [
        "960"
      ],
      capital: "Malé",
      region: "Asia",
      latlng: [
        3.25,
        73
      ],
      demonym: "Maldivan",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mv.svg",
      currencies: [
        {
          code: "MVR",
          name: "Maldivian rufiyaa",
          symbol: ".ރ"
        }
      ]
    },
    {
      name: "Mali",
      nameRu: "Мали",
      alpha2Code: "ML",
      alpha3Code: "MLI",
      callingCodes: [
        "223"
      ],
      capital: "Bamako",
      region: "Africa",
      latlng: [
        17,
        -4
      ],
      demonym: "Malian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ml.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Malta",
      nameRu: "Мальта",
      alpha2Code: "MT",
      alpha3Code: "MLT",
      callingCodes: [
        "356"
      ],
      capital: "Valletta",
      region: "Europe",
      latlng: [
        35.83333333,
        14.58333333
      ],
      demonym: "Maltese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Marshall Islands",
      nameRu: "Маршалловы Острова",
      alpha2Code: "MH",
      alpha3Code: "MHL",
      callingCodes: [
        "692"
      ],
      capital: "Majuro",
      region: "Oceania",
      latlng: [
        9,
        168
      ],
      demonym: "Marshallese",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mh.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Martinique",
      nameRu: "Мартиника",
      alpha2Code: "MQ",
      alpha3Code: "MTQ",
      callingCodes: [
        "596"
      ],
      capital: "Fort-de-France",
      region: "Americas",
      latlng: [
        14.666667,
        -61
      ],
      demonym: "French",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mq.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mauritania",
      nameRu: "Мавритания",
      alpha2Code: "MR",
      alpha3Code: "MRT",
      callingCodes: [
        "222"
      ],
      capital: "Nouakchott",
      region: "Africa",
      latlng: [
        20,
        -12
      ],
      demonym: "Mauritanian",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mr.svg",
      currencies: [
        {
          code: "MRO",
          name: "Mauritanian ouguiya",
          symbol: "UM"
        }
      ]
    },
    {
      name: "Mauritius",
      nameRu: "Маврикий",
      alpha2Code: "MU",
      alpha3Code: "MUS",
      callingCodes: [
        "230"
      ],
      capital: "Port Louis",
      region: "Africa",
      latlng: [
        -20.28333333,
        57.55
      ],
      demonym: "Mauritian",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mu.svg",
      currencies: [
        {
          code: "MUR",
          name: "Mauritian rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Mayotte",
      nameRu: "Майотта (Маоре)",
      alpha2Code: "YT",
      alpha3Code: "MYT",
      callingCodes: [
        "262"
      ],
      capital: "Mamoudzou",
      region: "Africa",
      latlng: [
        -12.83333333,
        45.16666666
      ],
      demonym: "French",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/yt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mexico",
      nameRu: "Мексика",
      alpha2Code: "MX",
      alpha3Code: "MEX",
      callingCodes: [
        "52"
      ],
      capital: "Mexico City",
      region: "Americas",
      latlng: [
        23,
        -102
      ],
      demonym: "Mexican",
      timezones: [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mx.svg",
      currencies: [
        {
          code: "MXN",
          name: "Mexican peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Micronesia (Federated States of)",
      nameRu: "Микронезия",
      alpha2Code: "FM",
      alpha3Code: "FSM",
      callingCodes: [
        "691"
      ],
      capital: "Palikir",
      region: "Oceania",
      latlng: [
        6.91666666,
        158.25
      ],
      demonym: "Micronesian",
      timezones: [
        "UTC+10:00",
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/fm.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Moldova (Republic of)",
      nameRu: "Молдавия (Молдова)",
      alpha2Code: "MD",
      alpha3Code: "MDA",
      callingCodes: [
        "373"
      ],
      capital: "Chișinău",
      region: "Europe",
      latlng: [
        47,
        29
      ],
      demonym: "Moldovan",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/md.svg",
      currencies: [
        {
          code: "MDL",
          name: "Moldovan leu",
          symbol: "L"
        }
      ]
    },
    {
      name: "Monaco",
      nameRu: "Монако",
      alpha2Code: "MC",
      alpha3Code: "MCO",
      callingCodes: [
        "377"
      ],
      capital: "Monaco",
      region: "Europe",
      latlng: [
        43.73333333,
        7.4
      ],
      demonym: "Monegasque",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mc.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Mongolia",
      nameRu: "Монголия",
      alpha2Code: "MN",
      alpha3Code: "MNG",
      callingCodes: [
        "976"
      ],
      capital: "Ulan Bator",
      region: "Asia",
      latlng: [
        46,
        105
      ],
      demonym: "Mongolian",
      timezones: [
        "UTC+07:00",
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mn.svg",
      currencies: [
        {
          code: "MNT",
          name: "Mongolian tögrög",
          symbol: "₮"
        }
      ]
    },
    {
      name: "Montenegro",
      nameRu: "Монтенегро",
      alpha2Code: "ME",
      alpha3Code: "MNE",
      callingCodes: [
        "382"
      ],
      capital: "Podgorica",
      region: "Europe",
      latlng: [
        42.5,
        19.3
      ],
      demonym: "Montenegrin",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/me.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Montserrat",
      nameRu: "Монтсеррат",
      alpha2Code: "MS",
      alpha3Code: "MSR",
      callingCodes: [
        "1"
      ],
      capital: "Plymouth",
      region: "Americas",
      latlng: [
        16.75,
        -62.2
      ],
      demonym: "Montserratian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ms.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Morocco",
      nameRu: "Марокко",
      alpha2Code: "MA",
      alpha3Code: "MAR",
      callingCodes: [
        "212"
      ],
      capital: "Rabat",
      region: "Africa",
      latlng: [
        32,
        -5
      ],
      demonym: "Moroccan",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ma.svg",
      currencies: [
        {
          code: "MAD",
          name: "Moroccan dirham",
          symbol: "د.م."
        }
      ]
    },
    {
      name: "Mozambique",
      nameRu: "Мозамбик",
      alpha2Code: "MZ",
      alpha3Code: "MOZ",
      callingCodes: [
        "258"
      ],
      capital: "Maputo",
      region: "Africa",
      latlng: [
        -18.25,
        35
      ],
      demonym: "Mozambican",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mz.svg",
      currencies: [
        {
          code: "MZN",
          name: "Mozambican metical",
          symbol: "MT"
        }
      ]
    },
    {
      name: "Myanmar",
      nameRu: "Мьянма",
      alpha2Code: "MM",
      alpha3Code: "MMR",
      callingCodes: [
        "95"
      ],
      capital: "Naypyidaw",
      region: "Asia",
      latlng: [
        22,
        98
      ],
      demonym: "Burmese",
      timezones: [
        "UTC+06:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mm.svg",
      currencies: [
        {
          code: "MMK",
          name: "Burmese kyat",
          symbol: "Ks"
        }
      ]
    },
    {
      name: "Namibia",
      nameRu: "Намибия",
      alpha2Code: "NA",
      alpha3Code: "NAM",
      callingCodes: [
        "264"
      ],
      capital: "Windhoek",
      region: "Africa",
      latlng: [
        -22,
        17
      ],
      demonym: "Namibian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/na.svg",
      currencies: [
        {
          code: "NAD",
          name: "Namibian dollar",
          symbol: "$"
        },
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "Nauru",
      nameRu: "Науру",
      alpha2Code: "NR",
      alpha3Code: "NRU",
      callingCodes: [
        "674"
      ],
      capital: "Yaren",
      region: "Oceania",
      latlng: [
        -0.53333333,
        166.91666666
      ],
      demonym: "Nauruan",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nr.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Nepal",
      nameRu: "Непал",
      alpha2Code: "NP",
      alpha3Code: "NPL",
      callingCodes: [
        "977"
      ],
      capital: "Kathmandu",
      region: "Asia",
      latlng: [
        28,
        84
      ],
      demonym: "Nepalese",
      timezones: [
        "UTC+05:45"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/np.svg",
      currencies: [
        {
          code: "NPR",
          name: "Nepalese rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Netherlands",
      nameRu: "Нидерланды",
      alpha2Code: "NL",
      alpha3Code: "NLD",
      callingCodes: [
        "31"
      ],
      capital: "Amsterdam",
      region: "Europe",
      latlng: [
        52.5,
        5.75
      ],
      demonym: "Dutch",
      timezones: [
        "UTC-04:00",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nl.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "New Caledonia",
      nameRu: "Новая Каледония",
      alpha2Code: "NC",
      alpha3Code: "NCL",
      callingCodes: [
        "687"
      ],
      capital: "Nouméa",
      region: "Oceania",
      latlng: [
        -21.5,
        165.5
      ],
      demonym: "New Caledonian",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nc.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "New Zealand",
      nameRu: "Новая Зеландия",
      alpha2Code: "NZ",
      alpha3Code: "NZL",
      callingCodes: [
        "64"
      ],
      capital: "Wellington",
      region: "Oceania",
      latlng: [
        -41,
        174
      ],
      demonym: "New Zealander",
      timezones: [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00",
        "UTC+12:45",
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nz.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Nicaragua",
      nameRu: "Никарагуа",
      alpha2Code: "NI",
      alpha3Code: "NIC",
      callingCodes: [
        "505"
      ],
      capital: "Managua",
      region: "Americas",
      latlng: [
        13,
        -85
      ],
      demonym: "Nicaraguan",
      timezones: [
        "UTC-06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ni.svg",
      currencies: [
        {
          code: "NIO",
          name: "Nicaraguan córdoba",
          symbol: "C$"
        }
      ]
    },
    {
      name: "Niger",
      nameRu: "Нигер",
      alpha2Code: "NE",
      alpha3Code: "NER",
      callingCodes: [
        "227"
      ],
      capital: "Niamey",
      region: "Africa",
      latlng: [
        16,
        8
      ],
      demonym: "Nigerien",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ne.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Nigeria",
      nameRu: "Нигерия",
      alpha2Code: "NG",
      alpha3Code: "NGA",
      callingCodes: [
        "234"
      ],
      capital: "Abuja",
      region: "Africa",
      latlng: [
        10,
        8
      ],
      demonym: "Nigerian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ng.svg",
      currencies: [
        {
          code: "NGN",
          name: "Nigerian naira",
          symbol: "₦"
        }
      ]
    },
    {
      name: "Niue",
      nameRu: "Ниуэ",
      alpha2Code: "NU",
      alpha3Code: "NIU",
      callingCodes: [
        "683"
      ],
      capital: "Alofi",
      region: "Oceania",
      latlng: [
        -19.03333333,
        -169.86666666
      ],
      demonym: "Niuean",
      timezones: [
        "UTC-11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nu.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "NZD",
          name: "Niue dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Norfolk Island",
      nameRu: "Норфолк",
      alpha2Code: "NF",
      alpha3Code: "NFK",
      callingCodes: [
        "672"
      ],
      capital: "Kingston",
      region: "Oceania",
      latlng: [
        -29.03333333,
        167.95
      ],
      demonym: "Norfolk Islander",
      timezones: [
        "UTC+11:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/nf.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Korea (Democratic People's Republic of)",
      nameRu: "Корейская Народно-Демократическая Республика (КНДР)",
      alpha2Code: "KP",
      alpha3Code: "PRK",
      callingCodes: [
        "850"
      ],
      capital: "Pyongyang",
      region: "Asia",
      latlng: [
        40,
        127
      ],
      demonym: "North Korean",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kp.svg",
      currencies: [
        {
          code: "KPW",
          name: "North Korean won",
          symbol: "₩"
        }
      ]
    },
    {
      name: "Northern Mariana Islands",
      nameRu: "Марианские Острова",
      alpha2Code: "MP",
      alpha3Code: "MNP",
      callingCodes: [
        "1"
      ],
      capital: "Saipan",
      region: "Oceania",
      latlng: [
        15.2,
        145.75
      ],
      demonym: "American",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/mp.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Norway",
      nameRu: "Норвения",
      alpha2Code: "NO",
      alpha3Code: "NOR",
      callingCodes: [
        "47"
      ],
      capital: "Oslo",
      region: "Europe",
      latlng: [
        62,
        10
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/no.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Oman",
      nameRu: "Оман",
      alpha2Code: "OM",
      alpha3Code: "OMN",
      callingCodes: [
        "968"
      ],
      capital: "Muscat",
      region: "Asia",
      latlng: [
        21,
        57
      ],
      demonym: "Omani",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/om.svg",
      currencies: [
        {
          code: "OMR",
          name: "Omani rial",
          symbol: "ر.ع."
        }
      ]
    },
    {
      name: "Pakistan",
      nameRu: "Пакистан",
      alpha2Code: "PK",
      alpha3Code: "PAK",
      callingCodes: [
        "92"
      ],
      capital: "Islamabad",
      region: "Asia",
      latlng: [
        30,
        70
      ],
      demonym: "Pakistani",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pk.svg",
      currencies: [
        {
          code: "PKR",
          name: "Pakistani rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Palau",
      nameRu: "Палау",
      alpha2Code: "PW",
      alpha3Code: "PLW",
      callingCodes: [
        "680"
      ],
      capital: "Ngerulmud",
      region: "Oceania",
      latlng: [
        7.5,
        134.5
      ],
      demonym: "Palauan",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pw.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Palestine, State of",
      nameRu: "Палестина",
      alpha2Code: "PS",
      alpha3Code: "PSE",
      callingCodes: [
        "970"
      ],
      capital: "Ramallah",
      region: "Asia",
      latlng: [
        31.9,
        35.2
      ],
      demonym: "Palestinian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ps.svg",
      currencies: [
        {
          code: "EGP",
          name: "Egyptian pound",
          symbol: "E£"
        },
        {
          code: "ILS",
          name: "Israeli new shekel",
          symbol: "₪"
        },
        {
          code: "JOD",
          name: "Jordanian dinar",
          symbol: "د.أ"
        }
      ]
    },
    {
      name: "Panama",
      nameRu: "Панама",
      alpha2Code: "PA",
      alpha3Code: "PAN",
      callingCodes: [
        "507"
      ],
      capital: "Panama City",
      region: "Americas",
      latlng: [
        9,
        -80
      ],
      demonym: "Panamanian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pa.svg",
      currencies: [
        {
          code: "PAB",
          name: "Panamanian balboa",
          symbol: "B/."
        },
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Papua New Guinea",
      nameRu: "Папуа - Новая Гвинея",
      alpha2Code: "PG",
      alpha3Code: "PNG",
      callingCodes: [
        "675"
      ],
      capital: "Port Moresby",
      region: "Oceania",
      latlng: [
        -6,
        147
      ],
      demonym: "Papua New Guinean",
      timezones: [
        "UTC+10:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pg.svg",
      currencies: [
        {
          code: "PGK",
          name: "Papua New Guinean kina",
          symbol: "K"
        }
      ]
    },
    {
      name: "Paraguay",
      nameRu: "Парагвай",
      alpha2Code: "PY",
      alpha3Code: "PRY",
      callingCodes: [
        "595"
      ],
      capital: "Asunción",
      region: "Americas",
      latlng: [
        -23,
        -58
      ],
      demonym: "Paraguayan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/py.svg",
      currencies: [
        {
          code: "PYG",
          name: "Paraguayan guaraní",
          symbol: "₲"
        }
      ]
    },
    {
      name: "Peru",
      nameRu: "Перу",
      alpha2Code: "PE",
      alpha3Code: "PER",
      callingCodes: [
        "51"
      ],
      capital: "Lima",
      region: "Americas",
      latlng: [
        -10,
        -76
      ],
      demonym: "Peruvian",
      timezones: [
        "UTC-05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pe.svg",
      currencies: [
        {
          code: "PEN",
          name: "Peruvian sol",
          symbol: "S/."
        }
      ]
    },
    {
      name: "Philippines",
      nameRu: "Филиппины",
      alpha2Code: "PH",
      alpha3Code: "PHL",
      callingCodes: [
        "63"
      ],
      capital: "Manila",
      region: "Asia",
      latlng: [
        13,
        122
      ],
      demonym: "Filipino",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ph.svg",
      currencies: [
        {
          code: "PHP",
          name: "Philippine peso",
          symbol: "₱"
        }
      ]
    },
    {
      name: "Pitcairn",
      nameRu: "Питкэрн",
      alpha2Code: "PN",
      alpha3Code: "PCN",
      callingCodes: [
        "64"
      ],
      capital: "Adamstown",
      region: "Oceania",
      latlng: [
        -25.06666666,
        -130.1
      ],
      demonym: "Pitcairn Islander",
      timezones: [
        "UTC-08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pn.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        },
        {
          code: "PND",
          name: "Pitcairn Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Poland",
      nameRu: "Польша",
      alpha2Code: "PL",
      alpha3Code: "POL",
      callingCodes: [
        "48"
      ],
      capital: "Warsaw",
      region: "Europe",
      latlng: [
        52,
        20
      ],
      demonym: "Polish",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pl.svg",
      currencies: [
        {
          code: "PLN",
          name: "Polish złoty",
          symbol: "zł"
        }
      ]
    },
    {
      name: "Portugal",
      nameRu: "Португалия",
      alpha2Code: "PT",
      alpha3Code: "PRT",
      callingCodes: [
        "351"
      ],
      capital: "Lisbon",
      region: "Europe",
      latlng: [
        39.5,
        -8
      ],
      demonym: "Portuguese",
      timezones: [
        "UTC-01:00",
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pt.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Puerto Rico",
      nameRu: "Пуэрто-Рико",
      alpha2Code: "PR",
      alpha3Code: "PRI",
      callingCodes: [
        "1"
      ],
      capital: "San Juan",
      region: "Americas",
      latlng: [
        18.25,
        -66.5
      ],
      demonym: "Puerto Rican",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pr.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Qatar",
      nameRu: "Катар",
      alpha2Code: "QA",
      alpha3Code: "QAT",
      callingCodes: [
        "974"
      ],
      capital: "Doha",
      region: "Asia",
      latlng: [
        25.5,
        51.25
      ],
      demonym: "Qatari",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/qa.svg",
      currencies: [
        {
          code: "QAR",
          name: "Qatari riyal",
          symbol: "ر.ق"
        }
      ]
    },
    // {
    //   name: "Republic of Kosovo",
    //   alpha2Code: "XK",
    //   alpha3Code: "UNK",
    //   callingCodes: [
    //     "383"
    //   ],
    //   capital: "Pristina",
    //   region: "Europe",
    //   latlng: [
    //     42.666667,
    //     21.166667
    //   ],
    //   demonym: "Kosovar",
    //   timezones: [
    //     "UTC+01:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/xk.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Réunion",
      nameRu: "Реюньон",
      alpha2Code: "RE",
      alpha3Code: "REU",
      callingCodes: [
        "262"
      ],
      capital: "Saint-Denis",
      region: "Africa",
      latlng: [
        -21.15,
        55.5
      ],
      demonym: "French",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/re.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Romania",
      nameRu: "Румыния",
      alpha2Code: "RO",
      alpha3Code: "ROU",
      callingCodes: [
        "40"
      ],
      capital: "Bucharest",
      region: "Europe",
      latlng: [
        46,
        25
      ],
      demonym: "Romanian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ro.svg",
      currencies: [
        {
          code: "RON",
          name: "Romanian leu",
          symbol: "lei"
        }
      ]
    },
    {
      name: "Russian Federation",
      nameRu: "Российская Федерация",
      alpha2Code: "RU",
      alpha3Code: "RUS",
      callingCodes: [
        "7"
      ],
      capital: "Moscow",
      region: "Europe",
      latlng: [
        60,
        100
      ],
      demonym: "Russian",
      timezones: [
        "UTC+03:00",
        "UTC+04:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ru.svg",
      currencies: [
        {
          code: "RUB",
          name: "Russian ruble",
          symbol: "₽"
        }
      ]
    },
    {
      name: "Rwanda",
      nameRu: "Руанда",
      alpha2Code: "RW",
      alpha3Code: "RWA",
      callingCodes: [
        "250"
      ],
      capital: "Kigali",
      region: "Africa",
      latlng: [
        -2,
        30
      ],
      demonym: "Rwandan",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/rw.svg",
      currencies: [
        {
          code: "RWF",
          name: "Rwandan franc",
          symbol: "Fr"
        }
      ]
    },
    // {
    //   name: "Saint Barthélemy",
    //   alpha2Code: "BL",
    //   alpha3Code: "BLM",
    //   callingCodes: [
    //     "590"
    //   ],
    //   capital: "Gustavia",
    //   region: "Americas",
    //   latlng: [
    //     18.5,
    //     -63.41666666
    //   ],
    //   demonym: "Saint Barthélemy Islander",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/bl.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      nameRu: "Остров Святой Елены",
      alpha2Code: "SH",
      alpha3Code: "SHN",
      callingCodes: [
        "290"
      ],
      capital: "Jamestown",
      region: "Africa",
      latlng: [
        -15.95,
        -5.7
      ],
      demonym: "Saint Helenian",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sh.svg",
      currencies: [
        {
          code: "SHP",
          name: "Saint Helena pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Saint Kitts and Nevis",
      nameRu: "Сент-Китс и Невис",
      alpha2Code: "KN",
      alpha3Code: "KNA",
      callingCodes: [
        "1"
      ],
      capital: "Basseterre",
      region: "Americas",
      latlng: [
        17.33333333,
        -62.75
      ],
      demonym: "Kittian and Nevisian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kn.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Saint Lucia",
      nameRu: "Сент-Люсия",
      alpha2Code: "LC",
      alpha3Code: "LCA",
      callingCodes: [
        "1"
      ],
      capital: "Castries",
      region: "Americas",
      latlng: [
        13.88333333,
        -60.96666666
      ],
      demonym: "Saint Lucian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lc.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    // {
    //   name: "Saint Martin (French part)",
    //   alpha2Code: "MF",
    //   alpha3Code: "MAF",
    //   callingCodes: [
    //     "590"
    //   ],
    //   capital: "Marigot",
    //   region: "Americas",
    //   latlng: [
    //     18.08333333,
    //     -63.95
    //   ],
    //   demonym: "Saint Martin Islander",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/mf.svg",
    //   currencies: [
    //     {
    //       code: "EUR",
    //       name: "Euro",
    //       symbol: "€"
    //     }
    //   ]
    // },
    {
      name: "Saint Pierre and Miquelon",
      nameRu: "Сен-Пьер и Микелон",
      alpha2Code: "PM",
      alpha3Code: "SPM",
      callingCodes: [
        "508"
      ],
      capital: "Saint-Pierre",
      region: "Americas",
      latlng: [
        46.83333333,
        -56.33333333
      ],
      demonym: "French",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/pm.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Saint Vincent and the Grenadines",
      nameRu: "Сент-Винсент и Гренадины",
      alpha2Code: "VC",
      alpha3Code: "VCT",
      callingCodes: [
        "1"
      ],
      capital: "Kingstown",
      region: "Americas",
      latlng: [
        13.25,
        -61.2
      ],
      demonym: "Saint Vincentian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vc.svg",
      currencies: [
        {
          code: "XCD",
          name: "East Caribbean dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Samoa",
      nameRu: "Западное Самоа",
      alpha2Code: "WS",
      alpha3Code: "WSM",
      callingCodes: [
        "685"
      ],
      capital: "Apia",
      region: "Oceania",
      latlng: [
        -13.58333333,
        -172.33333333
      ],
      demonym: "Samoan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ws.svg",
      currencies: [
        {
          code: "WST",
          name: "Samoan tālā",
          symbol: "T"
        }
      ]
    },
    { 
      name: "San Marino",
      nameRu: "Сан-Марино",
      alpha2Code: "SM",
      alpha3Code: "SMR",
      callingCodes: [
        "378"
      ],
      capital: "City of San Marino",
      region: "Europe",
      latlng: [
        43.76666666,
        12.41666666
      ],
      demonym: "Sammarinese",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sm.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Sao Tome and Principe",
      nameRu: "Сан-Томе и Принсипе",
      alpha2Code: "ST",
      alpha3Code: "STP",
      callingCodes: [
        "239"
      ],
      capital: "São Tomé",
      region: "Africa",
      latlng: [
        1,
        7
      ],
      demonym: "Sao Tomean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/st.svg",
      currencies: [
        {
          code: "STD",
          name: "São Tomé and Príncipe dobra",
          symbol: "Db"
        }
      ]
    },
    {
      name: "Saudi Arabia",
      nameRu: "Саудовская Аравия",
      alpha2Code: "SA",
      alpha3Code: "SAU",
      callingCodes: [
        "966"
      ],
      capital: "Riyadh",
      region: "Asia",
      latlng: [
        25,
        45
      ],
      demonym: "Saudi Arabian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sa.svg",
      currencies: [
        {
          code: "SAR",
          name: "Saudi riyal",
          symbol: "ر.س"
        }
      ]
    },
    {
      name: "Senegal",
      nameRu: "Сенегал",
      alpha2Code: "SN",
      alpha3Code: "SEN",
      callingCodes: [
        "221"
      ],
      capital: "Dakar",
      region: "Africa",
      latlng: [
        14,
        -14
      ],
      demonym: "Senegalese",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sn.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Serbia",
      nameRu: "Сербия",
      alpha2Code: "RS",
      alpha3Code: "SRB",
      callingCodes: [
        "381"
      ],
      capital: "Belgrade",
      region: "Europe",
      latlng: [
        44,
        21
      ],
      demonym: "Serbian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/rs.svg",
      currencies: [
        {
          code: "RSD",
          name: "Serbian dinar",
          symbol: "дин."
        }
      ]
    },
    {
      name: "Seychelles",
      nameRu: "Сейшельские Острова",
      alpha2Code: "SC",
      alpha3Code: "SYC",
      callingCodes: [
        "248"
      ],
      capital: "Victoria",
      region: "Africa",
      latlng: [
        -4.58333333,
        55.66666666
      ],
      demonym: "Seychellois",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sc.svg",
      currencies: [
        {
          code: "SCR",
          name: "Seychellois rupee",
          symbol: "₨"
        }
      ]
    },
    {
      name: "Sierra Leone",
      nameRu: "Сьерра-Леоне",
      alpha2Code: "SL",
      alpha3Code: "SLE",
      callingCodes: [
        "232"
      ],
      capital: "Freetown",
      region: "Africa",
      latlng: [
        8.5,
        -11.5
      ],
      demonym: "Sierra Leonean",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sl.svg",
      currencies: [
        {
          code: "SLL",
          name: "Sierra Leonean leone",
          symbol: "Le"
        }
      ]
    },
    {
      name: "Singapore",
      nameRu: "Сингапур",
      alpha2Code: "SG",
      alpha3Code: "SGP",
      callingCodes: [
        "65"
      ],
      capital: "Singapore",
      region: "Asia",
      latlng: [
        1.36666666,
        103.8
      ],
      demonym: "Singaporean",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sg.svg",
      currencies: [
        {
          code: "SGD",
          name: "Singapore dollar",
          symbol: "$"
        }
      ]
    },
    // {
    //   name: "Sint Maarten (Dutch part)",
    //   alpha2Code: "SX",
    //   alpha3Code: "SXM",
    //   callingCodes: [
    //     "1"
    //   ],
    //   capital: "Philipsburg",
    //   region: "Americas",
    //   latlng: [
    //     18.033333,
    //     -63.05
    //   ],
    //   demonym: "Dutch",
    //   timezones: [
    //     "UTC-04:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/sx.svg",
    //   currencies: [
    //     {
    //       code: "ANG",
    //       name: "Netherlands Antillean guilder",
    //       symbol: "ƒ"
    //     }
    //   ]
    // },
    {
      name: "Slovakia",
      nameRu: "Словакия",
      alpha2Code: "SK",
      alpha3Code: "SVK",
      callingCodes: [
        "421"
      ],
      capital: "Bratislava",
      region: "Europe",
      latlng: [
        48.66666666,
        19.5
      ],
      demonym: "Slovak",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sk.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Slovenia",
      nameRu: "Словения",
      alpha2Code: "SI",
      alpha3Code: "SVN",
      callingCodes: [
        "386"
      ],
      capital: "Ljubljana",
      region: "Europe",
      latlng: [
        46.11666666,
        14.81666666
      ],
      demonym: "Slovene",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/si.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Solomon Islands",
      nameRu: "Соломоновы Острова",
      alpha2Code: "SB",
      alpha3Code: "SLB",
      callingCodes: [
        "677"
      ],
      capital: "Honiara",
      region: "Oceania",
      latlng: [
        -8,
        159
      ],
      demonym: "Solomon Islander",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sb.svg",
      currencies: [
        {
          code: "SBD",
          name: "Solomon Islands dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Somalia",
      nameRu: "Сомали",
      alpha2Code: "SO",
      alpha3Code: "SOM",
      callingCodes: [
        "252"
      ],
      capital: "Mogadishu",
      region: "Africa",
      latlng: [
        10,
        49
      ],
      demonym: "Somali",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/so.svg",
      currencies: [
        {
          code: "SOS",
          name: "Somali shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "South Africa",
      nameRu: "Южно-Африканская Республика",
      alpha2Code: "ZA",
      alpha3Code: "ZAF",
      callingCodes: [
        "27"
      ],
      capital: "Pretoria",
      region: "Africa",
      latlng: [
        -29,
        24
      ],
      demonym: "South African",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/za.svg",
      currencies: [
        {
          code: "ZAR",
          name: "South African rand",
          symbol: "R"
        }
      ]
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      nameRu: "Южная Георгия и Южные Сандвичевы Острова",
      alpha2Code: "GS",
      alpha3Code: "SGS",
      callingCodes: [
        "500"
      ],
      capital: "King Edward Point",
      region: "Americas",
      latlng: [
        -54.5,
        -37
      ],
      demonym: "South Georgia and the South Sandwich Islander",
      timezones: [
        "UTC-02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gs.svg",
      currencies: [
        {
          code: "FKP",
          name: "Falkland Islands Pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Korea (Republic of)",
      nameRu: "Корея, Республика",
      alpha2Code: "KR",
      alpha3Code: "KOR",
      callingCodes: [
        "82"
      ],
      capital: "Seoul",
      region: "Asia",
      latlng: [
        37,
        127.5
      ],
      demonym: "South Korean",
      timezones: [
        "UTC+09:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/kr.svg",
      currencies: [
        {
          code: "KRW",
          name: "South Korean won",
          symbol: "₩"
        }
      ]
    },
    {
      name: "Spain",
      nameRu: "Испания",
      alpha2Code: "ES",
      alpha3Code: "ESP",
      callingCodes: [
        "34"
      ],
      capital: "Madrid",
      region: "Europe",
      latlng: [
        40,
        -4
      ],
      demonym: "Spanish",
      timezones: [
        "UTC",
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/es.svg",
      currencies: [
        {
          code: "EUR",
          name: "Euro",
          symbol: "€"
        }
      ]
    },
    {
      name: "Sri Lanka",
      nameRu: "Шри-Ланка",
      alpha2Code: "LK",
      alpha3Code: "LKA",
      callingCodes: [
        "94"
      ],
      capital: "Sri Jayawardenepura Kotte",
      region: "Asia",
      latlng: [
        7,
        81
      ],
      demonym: "Sri Lankan",
      timezones: [
        "UTC+05:30"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/lk.svg",
      currencies: [
        {
          code: "LKR",
          name: "Sri Lankan rupee",
          symbol: "Rs"
        }
      ]
    },
    {
      name: "Sudan",
      nameRu: "Судан",
      alpha2Code: "SD",
      alpha3Code: "SDN",
      callingCodes: [
        "249"
      ],
      capital: "Khartoum",
      region: "Africa",
      latlng: [
        15,
        30
      ],
      demonym: "Sudanese",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sd.svg",
      currencies: [
        {
          code: "SDG",
          name: "Sudanese pound",
          symbol: "ج.س."
        }
      ]
    },
    // {
    //   name: "South Sudan",
    //   alpha2Code: "SS",
    //   alpha3Code: "SSD",
    //   callingCodes: [
    //     "211"
    //   ],
    //   capital: "Juba",
    //   region: "Africa",
    //   latlng: [
    //     7,
    //     30
    //   ],
    //   demonym: "South Sudanese",
    //   timezones: [
    //     "UTC+03:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/ss.svg",
    //   currencies: [
    //     {
    //       code: "SSP",
    //       name: "South Sudanese pound",
    //       symbol: "£"
    //     }
    //   ]
    // },
    {
      name: "Suriname",
      nameRu: "Суринам",
      alpha2Code: "SR",
      alpha3Code: "SUR",
      callingCodes: [
        "597"
      ],
      capital: "Paramaribo",
      region: "Americas",
      latlng: [
        4,
        -56
      ],
      demonym: "Surinamer",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sr.svg",
      currencies: [
        {
          code: "SRD",
          name: "Surinamese dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Svalbard and Jan Mayen",
      nameRu: "Свальбард и Ян Майен",
      alpha2Code: "SJ",
      alpha3Code: "SJM",
      callingCodes: [
        "47"
      ],
      capital: "Longyearbyen",
      region: "Europe",
      latlng: [
        78,
        20
      ],
      demonym: "Norwegian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sj.svg",
      currencies: [
        {
          code: "NOK",
          name: "Norwegian krone",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Swaziland",
      nameRu: "Свазиленд",
      alpha2Code: "SZ",
      alpha3Code: "SWZ",
      callingCodes: [
        "268"
      ],
      capital: "Mbabane",
      region: "Africa",
      latlng: [
        -26.5,
        31.5
      ],
      demonym: "Swazi",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sz.svg",
      currencies: [
        {
          code: "SZL",
          name: "Swazi lilangeni",
          symbol: "L"
        }
      ]
    },
    {
      name: "Sweden",
      nameRu: "Швеция",
      alpha2Code: "SE",
      alpha3Code: "SWE",
      callingCodes: [
        "46"
      ],
      capital: "Stockholm",
      region: "Europe",
      latlng: [
        62,
        15
      ],
      demonym: "Swedish",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/se.svg",
      currencies: [
        {
          code: "SEK",
          name: "Swedish krona",
          symbol: "kr"
        }
      ]
    },
    {
      name: "Switzerland",
      nameRu: "Швейцария",
      alpha2Code: "CH",
      alpha3Code: "CHE",
      callingCodes: [
        "41"
      ],
      capital: "Bern",
      region: "Europe",
      latlng: [
        47,
        8
      ],
      demonym: "Swiss",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ch.svg",
      currencies: [
        {
          code: "CHF",
          name: "Swiss franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Syrian Arab Republic",
      nameRu: "Сирия",
      alpha2Code: "SY",
      alpha3Code: "SYR",
      callingCodes: [
        "963"
      ],
      capital: "Damascus",
      region: "Asia",
      latlng: [
        35,
        38
      ],
      demonym: "Syrian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/sy.svg",
      currencies: [
        {
          code: "SYP",
          name: "Syrian pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "Taiwan",
      nameRu: "Тайвань",
      alpha2Code: "TW",
      alpha3Code: "TWN",
      callingCodes: [
        "886"
      ],
      capital: "Taipei",
      region: "Asia",
      latlng: [
        23.5,
        121
      ],
      demonym: "Taiwanese",
      timezones: [
        "UTC+08:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tw.svg",
      currencies: [
        {
          code: "TWD",
          name: "New Taiwan dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tajikistan",
      nameRu: "Таджикистан",
      alpha2Code: "TJ",
      alpha3Code: "TJK",
      callingCodes: [
        "992"
      ],
      capital: "Dushanbe",
      region: "Asia",
      latlng: [
        39,
        71
      ],
      demonym: "Tadzhik",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tj.svg",
      currencies: [
        {
          code: "TJS",
          name: "Tajikistani somoni",
          symbol: "ЅМ"
        }
      ]
    },
    {
      name: "Tanzania, United Republic of",
      nameRu: "Танзания",
      alpha2Code: "TZ",
      alpha3Code: "TZA",
      callingCodes: [
        "255"
      ],
      capital: "Dodoma",
      region: "Africa",
      latlng: [
        -6,
        35
      ],
      demonym: "Tanzanian",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tz.svg",
      currencies: [
        {
          code: "TZS",
          name: "Tanzanian shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Thailand",
      nameRu: "Таиланд",
      alpha2Code: "TH",
      alpha3Code: "THA",
      callingCodes: [
        "66"
      ],
      capital: "Bangkok",
      region: "Asia",
      latlng: [
        15,
        100
      ],
      demonym: "Thai",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/th.svg",
      currencies: [
        {
          code: "THB",
          name: "Thai baht",
          symbol: "฿"
        }
      ]
    },
    // {
    //   name: "Timor-Leste",
    //   alpha2Code: "TL",
    //   alpha3Code: "TLS",
    //   callingCodes: [
    //     "670"
    //   ],
    //   capital: "Dili",
    //   region: "Asia",
    //   latlng: [
    //     -8.83333333,
    //     125.91666666
    //   ],
    //   demonym: "East Timorese",
    //   timezones: [
    //     "UTC+09:00"
    //   ],
    //   flag: "https://countryflagsapi.netlify.app/flag/tl.svg",
    //   currencies: [
    //     {
    //       code: "USD",
    //       name: "United States Dollar",
    //       symbol: "$"
    //     }
    //   ]
    // },
    {
      name: "Togo",
      nameRu: "Того",
      alpha2Code: "TG",
      alpha3Code: "TGO",
      callingCodes: [
        "228"
      ],
      capital: "Lomé",
      region: "Africa",
      latlng: [
        8,
        1.16666666
      ],
      demonym: "Togolese",
      timezones: [
        "UTC"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tg.svg",
      currencies: [
        {
          code: "XOF",
          name: "West African CFA franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Tokelau",
      nameRu: "Токелау",
      alpha2Code: "TK",
      alpha3Code: "TKL",
      callingCodes: [
        "690"
      ],
      capital: "Fakaofo",
      region: "Oceania",
      latlng: [
        -9,
        -172
      ],
      demonym: "Tokelauan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tk.svg",
      currencies: [
        {
          code: "NZD",
          name: "New Zealand dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tonga",
      nameRu: "Тонга",
      alpha2Code: "TO",
      alpha3Code: "TON",
      callingCodes: [
        "676"
      ],
      capital: "Nuku'alofa",
      region: "Oceania",
      latlng: [
        -20,
        -175
      ],
      demonym: "Tongan",
      timezones: [
        "UTC+13:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/to.svg",
      currencies: [
        {
          code: "TOP",
          name: "Tongan paʻanga",
          symbol: "T$"
        }
      ]
    },
    {
      name: "Trinidad and Tobago",
      nameRu: "Тринидад и Тобаго",
      alpha2Code: "TT",
      alpha3Code: "TTO",
      callingCodes: [
        "1"
      ],
      capital: "Port of Spain",
      region: "Americas",
      latlng: [
        11,
        -61
      ],
      demonym: "Trinidadian",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tt.svg",
      currencies: [
        {
          code: "TTD",
          name: "Trinidad and Tobago dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tunisia",
      nameRu: "Тунис",
      alpha2Code: "TN",
      alpha3Code: "TUN",
      callingCodes: [
        "216"
      ],
      capital: "Tunis",
      region: "Africa",
      latlng: [
        34,
        9
      ],
      demonym: "Tunisian",
      timezones: [
        "UTC+01:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tn.svg",
      currencies: [
        {
          code: "TND",
          name: "Tunisian dinar",
          symbol: "د.ت"
        }
      ]
    },
    {
      name: "Turkey",
      nameRu: "Турция",
      alpha2Code: "TR",
      alpha3Code: "TUR",
      callingCodes: [
        "90"
      ],
      capital: "Ankara",
      region: "Asia",
      latlng: [
        39,
        35
      ],
      demonym: "Turkish",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tr.svg",
      currencies: [
        {
          code: "TRY",
          name: "Turkish lira",
          symbol: "₺"
        }
      ]
    },
    {
      name: "Turkmenistan",
      nameRu: "Туркменистан",
      alpha2Code: "TM",
      alpha3Code: "TKM",
      callingCodes: [
        "993"
      ],
      capital: "Ashgabat",
      region: "Asia",
      latlng: [
        40,
        60
      ],
      demonym: "Turkmen",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tm.svg",
      currencies: [
        {
          code: "TMT",
          name: "Turkmenistan manat",
          symbol: "m"
        }
      ]
    },
    {
      name: "Turks and Caicos Islands",
      nameRu: "Теркс и Кайкос",
      alpha2Code: "TC",
      alpha3Code: "TCA",
      callingCodes: [
        "1"
      ],
      capital: "Cockburn Town",
      region: "Americas",
      latlng: [
        21.75,
        -71.58333333
      ],
      demonym: "Turks and Caicos Islander",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tc.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Tuvalu",
      nameRu: "Тувалу",
      alpha2Code: "TV",
      alpha3Code: "TUV",
      callingCodes: [
        "688"
      ],
      capital: "Funafuti",
      region: "Oceania",
      latlng: [
        -8,
        178
      ],
      demonym: "Tuvaluan",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/tv.svg",
      currencies: [
        {
          code: "AUD",
          name: "Australian dollar",
          symbol: "$"
        },
        {
          code: "TVD[G]",
          name: "Tuvaluan dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uganda",
      nameRu: "Уганда",
      alpha2Code: "UG",
      alpha3Code: "UGA",
      callingCodes: [
        "256"
      ],
      capital: "Kampala",
      region: "Africa",
      latlng: [
        1,
        32
      ],
      demonym: "Ugandan",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ug.svg",
      currencies: [
        {
          code: "UGX",
          name: "Ugandan shilling",
          symbol: "Sh"
        }
      ]
    },
    {
      name: "Ukraine",
      nameRu: "Украина",
      alpha2Code: "UA",
      alpha3Code: "UKR",
      callingCodes: [
        "380"
      ],
      capital: "Kyiv",
      region: "Europe",
      latlng: [
        49,
        32
      ],
      demonym: "Ukrainian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ua.svg",
      currencies: [
        {
          code: "UAH",
          name: "Ukrainian hryvnia",
          symbol: "₴"
        }
      ]
    },
    {
      name: "United Arab Emirates",
      nameRu: "Объединенные Арабские Эмираты",
      alpha2Code: "AE",
      alpha3Code: "ARE",
      callingCodes: [
        "971"
      ],
      capital: "Abu Dhabi",
      region: "Asia",
      latlng: [
        24,
        54
      ],
      demonym: "Emirati",
      timezones: [
        "UTC+04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ae.svg",
      currencies: [
        {
          code: "AED",
          name: "United Arab Emirates dirham",
          symbol: "د.إ"
        }
      ]
    },
    {
      name: "United Kingdom of Great Britain and Northern Ireland",
      nameRu: "Великобритания",
      alpha2Code: "GB",
      alpha3Code: "GBR",
      callingCodes: [
        "44"
      ],
      capital: "London",
      region: "Europe",
      latlng: [
        54,
        -2
      ],
      demonym: "British",
      timezones: [
        "UTC-08:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00",
        "UTC",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+06:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/gb.svg",
      currencies: [
        {
          code: "GBP",
          name: "British pound",
          symbol: "£"
        }
      ]
    },
    {
      name: "United States of America",
      nameRu: "Соединенные Штаты Америки (США)",
      alpha2Code: "US",
      alpha3Code: "USA",
      callingCodes: [
        "1"
      ],
      capital: "Washington, D.C.",
      region: "Americas",
      latlng: [
        38,
        -97
      ],
      demonym: "American",
      timezones: [
        "UTC-12:00",
        "UTC-11:00",
        "UTC-10:00",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/us.svg",
      currencies: [
        {
          code: "USD",
          name: "United States dollar",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uruguay",
      nameRu: "Уругвай",
      alpha2Code: "UY",
      alpha3Code: "URY",
      callingCodes: [
        "598"
      ],
      capital: "Montevideo",
      region: "Americas",
      latlng: [
        -33,
        -56
      ],
      demonym: "Uruguayan",
      timezones: [
        "UTC-03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/uy.svg",
      currencies: [
        {
          code: "UYU",
          name: "Uruguayan peso",
          symbol: "$"
        }
      ]
    },
    {
      name: "Uzbekistan",
      nameRu: "Узбекистан",
      alpha2Code: "UZ",
      alpha3Code: "UZB",
      callingCodes: [
        "998"
      ],
      capital: "Tashkent",
      region: "Asia",
      latlng: [
        41,
        64
      ],
      demonym: "Uzbekistani",
      timezones: [
        "UTC+05:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/uz.svg",
      currencies: [
        {
          code: "UZS",
          name: "Uzbekistani so'm",
          symbol: "so'm"
        }
      ]
    },
    {
      name: "Vanuatu",
      nameRu: "Вануату",
      alpha2Code: "VU",
      alpha3Code: "VUT",
      callingCodes: [
        "678"
      ],
      capital: "Port Vila",
      region: "Oceania",
      latlng: [
        -16,
        167
      ],
      demonym: "Ni-Vanuatu",
      timezones: [
        "UTC+11:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vu.svg",
      currencies: [
        {
          code: "VUV",
          name: "Vanuatu vatu",
          symbol: "Vt"
        }
      ]
    },
    {
      name: "Venezuela (Bolivarian Republic of)",
      nameRu: "Венесуэла",
      alpha2Code: "VE",
      alpha3Code: "VEN",
      callingCodes: [
        "58"
      ],
      capital: "Caracas",
      region: "Americas",
      latlng: [
        8,
        -66
      ],
      demonym: "Venezuelan",
      timezones: [
        "UTC-04:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ve.svg",
      currencies: [
        {
          code: "VEF",
          name: "Venezuelan bolívar",
          symbol: "Bs S"
        }
      ]
    },
    {
      name: "Vietnam",
      nameRu: "Вьетнам",
      alpha2Code: "VN",
      alpha3Code: "VNM",
      callingCodes: [
        "84"
      ],
      capital: "Hanoi",
      region: "Asia",
      latlng: [
        16.16666666,
        107.83333333
      ],
      demonym: "Vietnamese",
      timezones: [
        "UTC+07:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/vn.svg",
      currencies: [
        {
          code: "VND",
          name: "Vietnamese đồng",
          symbol: "₫"
        }
      ]
    },
    {
      name: "Wallis and Futuna",
      nameRu: "Уоллис и Футуна",
      alpha2Code: "WF",
      alpha3Code: "WLF",
      callingCodes: [
        "681"
      ],
      capital: "Mata-Utu",
      region: "Oceania",
      latlng: [
        -13.3,
        -176.2
      ],
      demonym: "Wallis and Futuna Islander",
      timezones: [
        "UTC+12:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/wf.svg",
      currencies: [
        {
          code: "XPF",
          name: "CFP franc",
          symbol: "Fr"
        }
      ]
    },
    {
      name: "Western Sahara",
      nameRu: "Западная Сахара",
      alpha2Code: "EH",
      alpha3Code: "ESH",
      callingCodes: [
        "212"
      ],
      capital: "El Aaiún",
      region: "Africa",
      latlng: [
        24.5,
        -13
      ],
      demonym: "Sahrawi",
      timezones: [
        "UTC+00:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/eh.svg",
      currencies: [
        {
          code: "MAD",
          name: "Moroccan dirham",
          symbol: "د.م."
        },
        {
          code: "DZD",
          name: "Algerian dinar",
          symbol: "د.ج"
        }
      ]
    },
    {
      name: "Yemen",
      nameRu: "Йемен",
      alpha2Code: "YE",
      alpha3Code: "YEM",
      callingCodes: [
        "967"
      ],
      capital: "Sana'a",
      region: "Asia",
      latlng: [
        15,
        48
      ],
      demonym: "Yemeni",
      timezones: [
        "UTC+03:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/ye.svg",
      currencies: [
        {
          code: "YER",
          name: "Yemeni rial",
          symbol: "﷼"
        }
      ]
    },
    {
      name: "Zambia",
      nameRu: "Замбия",
      alpha2Code: "ZM",
      alpha3Code: "ZMB",
      callingCodes: [
        "260"
      ],
      capital: "Lusaka",
      region: "Africa",
      latlng: [
        -15,
        30
      ],
      demonym: "Zambian",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/zm.svg",
      currencies: [
        {
          code: "ZMW",
          name: "Zambian kwacha",
          symbol: "ZK"
        }
      ]
    },
    {
      name: "Zimbabwe",
      nameRu: "Зимбабве",
      alpha2Code: "ZW",
      alpha3Code: "ZWE",
      callingCodes: [
        "263"
      ],
      capital: "Harare",
      region: "Africa",
      latlng: [
        -20,
        30
      ],
      demonym: "Zimbabwean",
      timezones: [
        "UTC+02:00"
      ],
      flag: "https://countryflagsapi.netlify.app/flag/zw.svg",
      currencies: [
        {
          code: "ZMW",
          name: "Zambian kwacha",
          symbol: "K"
        }
      ]
    }
  ]

export default CountriesList